import * as genericUtils from '@tolk-genii/generic-utils';
import * as browserUtils from '@tolk-genii/browser-utils';
import * as cryptojs from 'crypto-js';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$j =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$j = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$i = fails$j;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$i(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});

var fails$h = fails$j;

var functionBindNative = !fails$h(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$3 = functionBindNative;

var call$f = Function.prototype.call;

var functionCall = NATIVE_BIND$3 ? call$f.bind(call$f) : function () {
  return call$f.apply(call$f, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$2 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$2(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$4 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND$2 = functionBindNative;

var FunctionPrototype$2 = Function.prototype;
var call$e = FunctionPrototype$2.call;
var uncurryThisWithBind = NATIVE_BIND$2 && FunctionPrototype$2.bind.bind(call$e, call$e);

var functionUncurryThis = NATIVE_BIND$2 ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$e.apply(fn, arguments);
  };
};

var uncurryThis$i = functionUncurryThis;

var toString$5 = uncurryThis$i({}.toString);
var stringSlice$2 = uncurryThis$i(''.slice);

var classofRaw$2 = function (it) {
  return stringSlice$2(toString$5(it), 8, -1);
};

var uncurryThis$h = functionUncurryThis;
var fails$g = fails$j;
var classof$7 = classofRaw$2;

var $Object$4 = Object;
var split$1 = uncurryThis$h(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$g(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$7(it) === 'String' ? split$1(it, '') : $Object$4(it);
} : $Object$4;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$4 = function (it) {
  return it === null || it === undefined;
};

var isNullOrUndefined$3 = isNullOrUndefined$4;

var $TypeError$e = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$5 = function (it) {
  if (isNullOrUndefined$3(it)) throw new $TypeError$e("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$1 = indexedObject;
var requireObjectCoercible$4 = requireObjectCoercible$5;

var toIndexedObject$5 = function (it) {
  return IndexedObject$1(requireObjectCoercible$4(it));
};

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == 'object' && document.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var isCallable$k = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};

var isCallable$j = isCallable$k;

var isObject$c = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$j(it);
};

var global$i = global$j;
var isCallable$i = isCallable$k;

var aFunction = function (argument) {
  return isCallable$i(argument) ? argument : undefined;
};

var getBuiltIn$7 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$i[namespace]) : global$i[namespace] && global$i[namespace][method];
};

var uncurryThis$g = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$g({}.isPrototypeOf);

var engineUserAgent = typeof navigator != 'undefined' && String(navigator.userAgent) || '';

var global$h = global$j;
var userAgent$5 = engineUserAgent;

var process$3 = global$h.process;
var Deno$1 = global$h.Deno;
var versions = process$3 && process$3.versions || Deno$1 && Deno$1.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent$5) {
  match = userAgent$5.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent$5.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION$1 = engineV8Version;
var fails$f = fails$j;
var global$g = global$j;

var $String$5 = global$g.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$f(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String$5(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION$1 && V8_VERSION$1 < 41;
});

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL$1 = symbolConstructorDetection;

var useSymbolAsUid = NATIVE_SYMBOL$1
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var getBuiltIn$6 = getBuiltIn$7;
var isCallable$h = isCallable$k;
var isPrototypeOf$3 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var $Object$3 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$6('Symbol');
  return isCallable$h($Symbol) && isPrototypeOf$3($Symbol.prototype, $Object$3(it));
};

var $String$4 = String;

var tryToString$5 = function (argument) {
  try {
    return $String$4(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$g = isCallable$k;
var tryToString$4 = tryToString$5;

var $TypeError$d = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$9 = function (argument) {
  if (isCallable$g(argument)) return argument;
  throw new $TypeError$d(tryToString$4(argument) + ' is not a function');
};

var aCallable$8 = aCallable$9;
var isNullOrUndefined$2 = isNullOrUndefined$4;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$3 = function (V, P) {
  var func = V[P];
  return isNullOrUndefined$2(func) ? undefined : aCallable$8(func);
};

var call$d = functionCall;
var isCallable$f = isCallable$k;
var isObject$b = isObject$c;

var $TypeError$c = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$f(fn = input.toString) && !isObject$b(val = call$d(fn, input))) return val;
  if (isCallable$f(fn = input.valueOf) && !isObject$b(val = call$d(fn, input))) return val;
  if (pref !== 'string' && isCallable$f(fn = input.toString) && !isObject$b(val = call$d(fn, input))) return val;
  throw new $TypeError$c("Can't convert object to primitive value");
};

var sharedStore = {exports: {}};

var isPure = false;

var global$f = global$j;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$6 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$6(global$f, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$f[key] = value;
  } return value;
};

var globalThis$1 = global$j;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = sharedStore.exports = globalThis$1[SHARED] || defineGlobalProperty$2(SHARED, {});

(store$3.versions || (store$3.versions = [])).push({
  version: '3.37.1',
  mode: 'global',
  copyright: '© 2014-2024 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.37.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var store$2 = sharedStore.exports;

var shared$3 = function (key, value) {
  return store$2[key] || (store$2[key] = value || {});
};

var requireObjectCoercible$3 = requireObjectCoercible$5;

var $Object$2 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$4 = function (argument) {
  return $Object$2(requireObjectCoercible$3(argument));
};

var uncurryThis$f = functionUncurryThis;
var toObject$3 = toObject$4;

var hasOwnProperty = uncurryThis$f({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$3(it), key);
};

var uncurryThis$e = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$4 = uncurryThis$e(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$4(++id + postfix, 36);
};

var global$e = global$j;
var shared$2 = shared$3;
var hasOwn$b = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL = symbolConstructorDetection;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var Symbol$1 = global$e.Symbol;
var WellKnownSymbolsStore = shared$2('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1['for'] || Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$i = function (name) {
  if (!hasOwn$b(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn$b(Symbol$1, name)
      ? Symbol$1[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var call$c = functionCall;
var isObject$a = isObject$c;
var isSymbol$1 = isSymbol$2;
var getMethod$2 = getMethod$3;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$h = wellKnownSymbol$i;

var $TypeError$b = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$h('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$a(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$2(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$c(exoticToPrim, input, pref);
    if (!isObject$a(result) || isSymbol$1(result)) return result;
    throw new $TypeError$b("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var global$d = global$j;
var isObject$9 = isObject$c;

var document$3 = global$d.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$9(document$3) && isObject$9(document$3.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$3.createElement(it) : {};
};

var DESCRIPTORS$d = descriptors;
var fails$e = fails$j;
var createElement$1 = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$d && !fails$e(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement$1('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});

var DESCRIPTORS$c = descriptors;
var call$b = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$3 = createPropertyDescriptor$4;
var toIndexedObject$4 = toIndexedObject$5;
var toPropertyKey$1 = toPropertyKey$2;
var hasOwn$a = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$c ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$4(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$a(O, P)) return createPropertyDescriptor$3(!call$b(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$b = descriptors;
var fails$d = fails$j;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$b && fails$d(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});

var isObject$8 = isObject$c;

var $String$3 = String;
var $TypeError$a = TypeError;

// `Assert: Type(argument) is Object`
var anObject$c = function (argument) {
  if (isObject$8(argument)) return argument;
  throw new $TypeError$a($String$3(argument) + ' is not an object');
};

var DESCRIPTORS$a = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$b = anObject$c;
var toPropertyKey = toPropertyKey$2;

var $TypeError$9 = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$a ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$b(O);
  P = toPropertyKey(P);
  anObject$b(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$b(O);
  P = toPropertyKey(P);
  anObject$b(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError$9('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$9 = descriptors;
var definePropertyModule$3 = objectDefineProperty;
var createPropertyDescriptor$2 = createPropertyDescriptor$4;

var createNonEnumerableProperty$4 = DESCRIPTORS$9 ? function (object, key, value) {
  return definePropertyModule$3.f(object, key, createPropertyDescriptor$2(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$3 = {exports: {}};

var DESCRIPTORS$8 = descriptors;
var hasOwn$9 = hasOwnProperty_1;

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$8 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$9(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$8 || (DESCRIPTORS$8 && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$d = functionUncurryThis;
var isCallable$e = isCallable$k;
var store$1 = sharedStore.exports;

var functionToString = uncurryThis$d(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$e(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$3 = store$1.inspectSource;

var global$c = global$j;
var isCallable$d = isCallable$k;

var WeakMap$1 = global$c.WeakMap;

var weakMapBasicDetection = isCallable$d(WeakMap$1) && /native code/.test(String(WeakMap$1));

var shared$1 = shared$3;
var uid = uid$2;

var keys = shared$1('keys');

var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = weakMapBasicDetection;
var global$b = global$j;
var isObject$7 = isObject$c;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$4;
var hasOwn$8 = hasOwnProperty_1;
var shared = sharedStore.exports;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$3 = global$b.TypeError;
var WeakMap = global$b.WeakMap;
var set$1, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set$1(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$7(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError$3('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set$1 = function (it, metadata) {
    if (store.has(it)) throw new TypeError$3(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set$1 = function (it, metadata) {
    if (hasOwn$8(it, STATE)) throw new TypeError$3(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$3(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$8(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$8(it, STATE);
  };
}

var internalState = {
  set: set$1,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var uncurryThis$c = functionUncurryThis;
var fails$c = fails$j;
var isCallable$c = isCallable$k;
var hasOwn$7 = hasOwnProperty_1;
var DESCRIPTORS$7 = descriptors;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var inspectSource$2 = inspectSource$3;
var InternalStateModule$3 = internalState;

var enforceInternalState = InternalStateModule$3.enforce;
var getInternalState$1 = InternalStateModule$3.get;
var $String$2 = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$5 = Object.defineProperty;
var stringSlice$1 = uncurryThis$c(''.slice);
var replace$2 = uncurryThis$c(''.replace);
var join$1 = uncurryThis$c([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS$7 && !fails$c(function () {
  return defineProperty$5(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$2 = makeBuiltIn$3.exports = function (value, name, options) {
  if (stringSlice$1($String$2(name), 0, 7) === 'Symbol(') {
    name = '[' + replace$2($String$2(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$7(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
    if (DESCRIPTORS$7) defineProperty$5(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$7(options, 'arity') && value.length !== options.arity) {
    defineProperty$5(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$7(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$7) defineProperty$5(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn$7(state, 'source')) {
    state.source = join$1(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$2(function toString() {
  return isCallable$c(this) && getInternalState$1(this).source || inspectSource$2(this);
}, 'toString');

var isCallable$b = isCallable$k;
var definePropertyModule$2 = objectDefineProperty;
var makeBuiltIn$1 = makeBuiltIn$3.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$8 = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$b(value)) makeBuiltIn$1(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$2.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor$1 = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor$1 : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$2 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$1 = toIntegerOrInfinity$2;

var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$1(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

var toIntegerOrInfinity = toIntegerOrInfinity$2;

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$1 = function (argument) {
  var len = toIntegerOrInfinity(argument);
  return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength = toLength$1;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$3 = function (obj) {
  return toLength(obj.length);
};

var toIndexedObject$3 = toIndexedObject$5;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike$2 = lengthOfArrayLike$3;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$1 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$3($this);
    var length = lengthOfArrayLike$2(O);
    if (length === 0) return !IS_INCLUDES && -1;
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$1(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$1(false)
};

var uncurryThis$b = functionUncurryThis;
var hasOwn$6 = hasOwnProperty_1;
var toIndexedObject$2 = toIndexedObject$5;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var push$2 = uncurryThis$b([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$2(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$6(hiddenKeys$2, key) && hasOwn$6(O, key) && push$2(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$6(O, key = names[i++])) {
    ~indexOf(result, key) || push$2(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$5 = getBuiltIn$7;
var uncurryThis$a = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$a = anObject$c;

var concat$1 = uncurryThis$a([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$5('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$a(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$1(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$5 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$1 = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$1.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$5(target, key) && !(exceptions && hasOwn$5(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$b = fails$j;
var isCallable$a = isCallable$k;

var replacement = /#|\.prototype\./;

var isForced$2 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable$a(detection) ? fails$b(detection)
    : !!detection;
};

var normalize = isForced$2.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$2.data = {};
var NATIVE = isForced$2.NATIVE = 'N';
var POLYFILL = isForced$2.POLYFILL = 'P';

var isForced_1 = isForced$2;

var global$a = global$j;
var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$4;
var defineBuiltIn$7 = defineBuiltIn$8;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced$1 = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$a;
  } else if (STATIC) {
    target = global$a[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = global$a[TARGET] && global$a[TARGET].prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$2(sourceProperty, 'sham', true);
    }
    defineBuiltIn$7(target, key, sourceProperty, options);
  }
};

var global$9 = global$j;
var classof$6 = classofRaw$2;

var engineIsNode = classof$6(global$9.process) === 'process';

var uncurryThis$9 = functionUncurryThis;
var aCallable$7 = aCallable$9;

var functionUncurryThisAccessor = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis$9(aCallable$7(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};

var isObject$6 = isObject$c;

var isPossiblePrototype$1 = function (argument) {
  return isObject$6(argument) || argument === null;
};

var isPossiblePrototype = isPossiblePrototype$1;

var $String$1 = String;
var $TypeError$8 = TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (isPossiblePrototype(argument)) return argument;
  throw new $TypeError$8("Can't set " + $String$1(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = functionUncurryThisAccessor;
var isObject$5 = isObject$c;
var requireObjectCoercible$2 = requireObjectCoercible$5;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    requireObjectCoercible$2(O);
    aPossiblePrototype(proto);
    if (!isObject$5(O)) return O;
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var defineProperty$4 = objectDefineProperty.f;
var hasOwn$4 = hasOwnProperty_1;
var wellKnownSymbol$g = wellKnownSymbol$i;

var TO_STRING_TAG$2 = wellKnownSymbol$g('toStringTag');

var setToStringTag$5 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$4(target, TO_STRING_TAG$2)) {
    defineProperty$4(target, TO_STRING_TAG$2, { configurable: true, value: TAG });
  }
};

var makeBuiltIn = makeBuiltIn$3.exports;
var defineProperty$3 = objectDefineProperty;

var defineBuiltInAccessor$2 = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty$3.f(target, name, descriptor);
};

var getBuiltIn$4 = getBuiltIn$7;
var defineBuiltInAccessor$1 = defineBuiltInAccessor$2;
var wellKnownSymbol$f = wellKnownSymbol$i;
var DESCRIPTORS$6 = descriptors;

var SPECIES$2 = wellKnownSymbol$f('species');

var setSpecies$1 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$4(CONSTRUCTOR_NAME);

  if (DESCRIPTORS$6 && Constructor && !Constructor[SPECIES$2]) {
    defineBuiltInAccessor$1(Constructor, SPECIES$2, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var isPrototypeOf$2 = objectIsPrototypeOf;

var $TypeError$7 = TypeError;

var anInstance$2 = function (it, Prototype) {
  if (isPrototypeOf$2(Prototype, it)) return it;
  throw new $TypeError$7('Incorrect invocation');
};

var wellKnownSymbol$e = wellKnownSymbol$i;

var TO_STRING_TAG$1 = wellKnownSymbol$e('toStringTag');
var test$1 = {};

test$1[TO_STRING_TAG$1] = 'z';

var toStringTagSupport = String(test$1) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$9 = isCallable$k;
var classofRaw$1 = classofRaw$2;
var wellKnownSymbol$d = wellKnownSymbol$i;

var TO_STRING_TAG = wellKnownSymbol$d('toStringTag');
var $Object$1 = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw$1(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$5 = TO_STRING_TAG_SUPPORT ? classofRaw$1 : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object$1(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw$1(O)
    // ES3 arguments fallback
    : (result = classofRaw$1(O)) === 'Object' && isCallable$9(O.callee) ? 'Arguments' : result;
};

var uncurryThis$8 = functionUncurryThis;
var fails$a = fails$j;
var isCallable$8 = isCallable$k;
var classof$4 = classof$5;
var getBuiltIn$3 = getBuiltIn$7;
var inspectSource$1 = inspectSource$3;

var noop = function () { /* empty */ };
var construct = getBuiltIn$3('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis$8(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.test(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable$8(argument)) return false;
  try {
    construct(noop, [], argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable$8(argument)) return false;
  switch (classof$4(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource$1(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$1 = !construct || fails$a(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var isConstructor = isConstructor$1;
var tryToString$3 = tryToString$5;

var $TypeError$6 = TypeError;

// `Assert: IsConstructor(argument) is true`
var aConstructor$1 = function (argument) {
  if (isConstructor(argument)) return argument;
  throw new $TypeError$6(tryToString$3(argument) + ' is not a constructor');
};

var anObject$9 = anObject$c;
var aConstructor = aConstructor$1;
var isNullOrUndefined$1 = isNullOrUndefined$4;
var wellKnownSymbol$c = wellKnownSymbol$i;

var SPECIES$1 = wellKnownSymbol$c('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor$1 = function (O, defaultConstructor) {
  var C = anObject$9(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined$1(S = anObject$9(C)[SPECIES$1]) ? defaultConstructor : aConstructor(S);
};

var NATIVE_BIND$1 = functionBindNative;

var FunctionPrototype = Function.prototype;
var apply$1 = FunctionPrototype.apply;
var call$a = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND$1 ? call$a.bind(apply$1) : function () {
  return call$a.apply(apply$1, arguments);
});

var classofRaw = classofRaw$2;
var uncurryThis$7 = functionUncurryThis;

var functionUncurryThisClause = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis$7(fn);
};

var uncurryThis$6 = functionUncurryThisClause;
var aCallable$6 = aCallable$9;
var NATIVE_BIND = functionBindNative;

var bind$5 = uncurryThis$6(uncurryThis$6.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable$6(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind$5(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var getBuiltIn$2 = getBuiltIn$7;

var html$2 = getBuiltIn$2('document', 'documentElement');

var uncurryThis$5 = functionUncurryThis;

var arraySlice$2 = uncurryThis$5([].slice);

var $TypeError$5 = TypeError;

var validateArgumentsLength$2 = function (passed, required) {
  if (passed < required) throw new $TypeError$5('Not enough arguments');
  return passed;
};

var userAgent$4 = engineUserAgent;

// eslint-disable-next-line redos/no-vulnerable -- safe
var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent$4);

var global$8 = global$j;
var apply = functionApply;
var bind$4 = functionBindContext;
var isCallable$7 = isCallable$k;
var hasOwn$3 = hasOwnProperty_1;
var fails$9 = fails$j;
var html$1 = html$2;
var arraySlice$1 = arraySlice$2;
var createElement = documentCreateElement$2;
var validateArgumentsLength$1 = validateArgumentsLength$2;
var IS_IOS$1 = engineIsIos;
var IS_NODE$3 = engineIsNode;

var set = global$8.setImmediate;
var clear = global$8.clearImmediate;
var process$2 = global$8.process;
var Dispatch = global$8.Dispatch;
var Function$1 = global$8.Function;
var MessageChannel = global$8.MessageChannel;
var String$1 = global$8.String;
var counter = 0;
var queue$2 = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

fails$9(function () {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = global$8.location;
});

var run = function (id) {
  if (hasOwn$3(queue$2, id)) {
    var fn = queue$2[id];
    delete queue$2[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var eventListener = function (event) {
  run(event.data);
};

var globalPostMessageDefer = function (id) {
  // old engines have not location.origin
  global$8.postMessage(String$1(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength$1(arguments.length, 1);
    var fn = isCallable$7(handler) ? handler : Function$1(handler);
    var args = arraySlice$1(arguments, 1);
    queue$2[++counter] = function () {
      apply(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue$2[id];
  };
  // Node.js 0.8-
  if (IS_NODE$3) {
    defer = function (id) {
      process$2.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS$1) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = eventListener;
    defer = bind$4(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global$8.addEventListener &&
    isCallable$7(global$8.postMessage) &&
    !global$8.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails$9(globalPostMessageDefer)
  ) {
    defer = globalPostMessageDefer;
    global$8.addEventListener('message', eventListener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html$1.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html$1.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task$1 = {
  set: set,
  clear: clear
};

var global$7 = global$j;
var DESCRIPTORS$5 = descriptors;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
var safeGetBuiltIn$2 = function (name) {
  if (!DESCRIPTORS$5) return global$7[name];
  var descriptor = getOwnPropertyDescriptor(global$7, name);
  return descriptor && descriptor.value;
};

var Queue$2 = function () {
  this.head = null;
  this.tail = null;
};

Queue$2.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    var tail = this.tail;
    if (tail) tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      var next = this.head = entry.next;
      if (next === null) this.tail = null;
      return entry.item;
    }
  }
};

var queue$1 = Queue$2;

var userAgent$3 = engineUserAgent;

var engineIsIosPebble = /ipad|iphone|ipod/i.test(userAgent$3) && typeof Pebble != 'undefined';

var userAgent$2 = engineUserAgent;

var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent$2);

var global$6 = global$j;
var safeGetBuiltIn$1 = safeGetBuiltIn$2;
var bind$3 = functionBindContext;
var macrotask = task$1.set;
var Queue$1 = queue$1;
var IS_IOS = engineIsIos;
var IS_IOS_PEBBLE = engineIsIosPebble;
var IS_WEBOS_WEBKIT = engineIsWebosWebkit;
var IS_NODE$2 = engineIsNode;

var MutationObserver = global$6.MutationObserver || global$6.WebKitMutationObserver;
var document$2 = global$6.document;
var process$1 = global$6.process;
var Promise$1 = global$6.Promise;
var microtask$1 = safeGetBuiltIn$1('queueMicrotask');
var notify$1, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!microtask$1) {
  var queue = new Queue$1();

  var flush = function () {
    var parent, fn;
    if (IS_NODE$2 && (parent = process$1.domain)) parent.exit();
    while (fn = queue.get()) try {
      fn();
    } catch (error) {
      if (queue.head) notify$1();
      throw error;
    }
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE$2 && !IS_WEBOS_WEBKIT && MutationObserver && document$2) {
    toggle = true;
    node = document$2.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify$1 = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise$1;
    then = bind$3(promise.then, promise);
    notify$1 = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE$2) {
    notify$1 = function () {
      process$1.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // `webpack` dev server bug on IE global methods - use bind(fn, global)
    macrotask = bind$3(macrotask, global$6);
    notify$1 = function () {
      macrotask(flush);
    };
  }

  microtask$1 = function (fn) {
    if (!queue.head) notify$1();
    queue.add(fn);
  };
}

var microtask_1 = microtask$1;

var hostReportErrors$1 = function (a, b) {
  try {
    // eslint-disable-next-line no-console -- safe
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  } catch (error) { /* empty */ }
};

var perform$3 = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var global$5 = global$j;

var promiseNativeConstructor = global$5.Promise;

/* global Deno -- Deno case */
var engineIsDeno = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';

var IS_DENO$1 = engineIsDeno;
var IS_NODE$1 = engineIsNode;

var engineIsBrowser = !IS_DENO$1 && !IS_NODE$1
  && typeof window == 'object'
  && typeof document == 'object';

var global$4 = global$j;
var NativePromiseConstructor$3 = promiseNativeConstructor;
var isCallable$6 = isCallable$k;
var isForced = isForced_1;
var inspectSource = inspectSource$3;
var wellKnownSymbol$b = wellKnownSymbol$i;
var IS_BROWSER = engineIsBrowser;
var IS_DENO = engineIsDeno;
var V8_VERSION = engineV8Version;

NativePromiseConstructor$3 && NativePromiseConstructor$3.prototype;
var SPECIES = wellKnownSymbol$b('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT$1 = isCallable$6(global$4.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR$5 = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor$3);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor$3);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor$3(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT$1;
});

var promiseConstructorDetection = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR$5,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT$1,
  SUBCLASSING: SUBCLASSING
};

var newPromiseCapability$2 = {};

var aCallable$5 = aCallable$9;

var $TypeError$4 = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw new $TypeError$4('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable$5(resolve);
  this.reject = aCallable$5(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
newPromiseCapability$2.f = function (C) {
  return new PromiseCapability(C);
};

var $$c = _export;
var IS_NODE = engineIsNode;
var global$3 = global$j;
var call$9 = functionCall;
var defineBuiltIn$6 = defineBuiltIn$8;
var setPrototypeOf$1 = objectSetPrototypeOf;
var setToStringTag$4 = setToStringTag$5;
var setSpecies = setSpecies$1;
var aCallable$4 = aCallable$9;
var isCallable$5 = isCallable$k;
var isObject$4 = isObject$c;
var anInstance$1 = anInstance$2;
var speciesConstructor = speciesConstructor$1;
var task = task$1.set;
var microtask = microtask_1;
var hostReportErrors = hostReportErrors$1;
var perform$2 = perform$3;
var Queue = queue$1;
var InternalStateModule$2 = internalState;
var NativePromiseConstructor$2 = promiseNativeConstructor;
var PromiseConstructorDetection = promiseConstructorDetection;
var newPromiseCapabilityModule$3 = newPromiseCapability$2;

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR$4 = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule$2.getterFor(PROMISE);
var setInternalState$2 = InternalStateModule$2.set;
var NativePromisePrototype$1 = NativePromiseConstructor$2 && NativePromiseConstructor$2.prototype;
var PromiseConstructor = NativePromiseConstructor$2;
var PromisePrototype = NativePromisePrototype$1;
var TypeError$2 = global$3.TypeError;
var document$1 = global$3.document;
var process = global$3.process;
var newPromiseCapability$1 = newPromiseCapabilityModule$3.f;
var newGenericPromiseCapability = newPromiseCapability$1;

var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$3.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject$4(it) && isCallable$5(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state === FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(new TypeError$2('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call$9(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global$3.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global$3['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call$9(task, global$3, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform$2(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call$9(task, global$3, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind$2 = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw new TypeError$2("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call$9(then, value,
            bind$2(internalResolve, wrapper, state),
            bind$2(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR$4) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance$1(this, PromisePrototype);
    aCallable$4(executor);
    call$9(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind$2(internalResolve, state), bind$2(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState$2(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn$6(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability$1(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable$5(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable$5(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process.domain : undefined;
    if (state.state === PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind$2(internalResolve, state);
    this.reject = bind$2(internalReject, state);
  };

  newPromiseCapabilityModule$3.f = newPromiseCapability$1 = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (isCallable$5(NativePromiseConstructor$2) && NativePromisePrototype$1 !== Object.prototype) {
    nativeThen = NativePromisePrototype$1.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn$6(NativePromisePrototype$1, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call$9(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype$1.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf$1) {
      setPrototypeOf$1(NativePromisePrototype$1, PromisePrototype);
    }
  }
}

$$c({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR$4 }, {
  Promise: PromiseConstructor
});

setToStringTag$4(PromiseConstructor, PROMISE, false);
setSpecies(PROMISE);

var iterators = {};

var wellKnownSymbol$a = wellKnownSymbol$i;
var Iterators$4 = iterators;

var ITERATOR$7 = wellKnownSymbol$a('iterator');
var ArrayPrototype$1 = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$1 = function (it) {
  return it !== undefined && (Iterators$4.Array === it || ArrayPrototype$1[ITERATOR$7] === it);
};

var classof$3 = classof$5;
var getMethod$1 = getMethod$3;
var isNullOrUndefined = isNullOrUndefined$4;
var Iterators$3 = iterators;
var wellKnownSymbol$9 = wellKnownSymbol$i;

var ITERATOR$6 = wellKnownSymbol$9('iterator');

var getIteratorMethod$3 = function (it) {
  if (!isNullOrUndefined(it)) return getMethod$1(it, ITERATOR$6)
    || getMethod$1(it, '@@iterator')
    || Iterators$3[classof$3(it)];
};

var call$8 = functionCall;
var aCallable$3 = aCallable$9;
var anObject$8 = anObject$c;
var tryToString$2 = tryToString$5;
var getIteratorMethod$2 = getIteratorMethod$3;

var $TypeError$3 = TypeError;

var getIterator$2 = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$2(argument) : usingIterator;
  if (aCallable$3(iteratorMethod)) return anObject$8(call$8(iteratorMethod, argument));
  throw new $TypeError$3(tryToString$2(argument) + ' is not iterable');
};

var call$7 = functionCall;
var anObject$7 = anObject$c;
var getMethod = getMethod$3;

var iteratorClose$1 = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject$7(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call$7(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$7(innerResult);
  return value;
};

var bind$1 = functionBindContext;
var call$6 = functionCall;
var anObject$6 = anObject$c;
var tryToString$1 = tryToString$5;
var isArrayIteratorMethod = isArrayIteratorMethod$1;
var lengthOfArrayLike$1 = lengthOfArrayLike$3;
var isPrototypeOf$1 = objectIsPrototypeOf;
var getIterator$1 = getIterator$2;
var getIteratorMethod$1 = getIteratorMethod$3;
var iteratorClose = iteratorClose$1;

var $TypeError$2 = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

var iterate$2 = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind$1(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject$6(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod$1(iterable);
    if (!iterFn) throw new $TypeError$2(tryToString$1(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike$1(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf$1(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator$1(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call$6(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf$1(ResultPrototype, result)) return result;
  } return new Result(false);
};

var wellKnownSymbol$8 = wellKnownSymbol$i;

var ITERATOR$5 = wellKnownSymbol$8('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$5] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration$1 = function (exec, SKIP_CLOSING) {
  try {
    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  } catch (error) { return false; } // workaround of old WebKit + `eval` bug
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$5] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var NativePromiseConstructor$1 = promiseNativeConstructor;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$1;
var FORCED_PROMISE_CONSTRUCTOR$3 = promiseConstructorDetection.CONSTRUCTOR;

var promiseStaticsIncorrectIteration = FORCED_PROMISE_CONSTRUCTOR$3 || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor$1.all(iterable).then(undefined, function () { /* empty */ });
});

var $$b = _export;
var call$5 = functionCall;
var aCallable$2 = aCallable$9;
var newPromiseCapabilityModule$2 = newPromiseCapability$2;
var perform$1 = perform$3;
var iterate$1 = iterate$2;
var PROMISE_STATICS_INCORRECT_ITERATION$1 = promiseStaticsIncorrectIteration;

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$$b({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION$1 }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$2.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform$1(function () {
      var $promiseResolve = aCallable$2(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate$1(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call$5($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$a = _export;
var FORCED_PROMISE_CONSTRUCTOR$2 = promiseConstructorDetection.CONSTRUCTOR;
var NativePromiseConstructor = promiseNativeConstructor;
var getBuiltIn$1 = getBuiltIn$7;
var isCallable$4 = isCallable$k;
var defineBuiltIn$5 = defineBuiltIn$8;

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$$a({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR$2, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (isCallable$4(NativePromiseConstructor)) {
  var method = getBuiltIn$1('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn$5(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}

var $$9 = _export;
var call$4 = functionCall;
var aCallable$1 = aCallable$9;
var newPromiseCapabilityModule$1 = newPromiseCapability$2;
var perform = perform$3;
var iterate = iterate$2;
var PROMISE_STATICS_INCORRECT_ITERATION = promiseStaticsIncorrectIteration;

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$$9({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$1.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable$1(C.resolve);
      iterate(iterable, function (promise) {
        call$4($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$8 = _export;
var newPromiseCapabilityModule = newPromiseCapability$2;
var FORCED_PROMISE_CONSTRUCTOR$1 = promiseConstructorDetection.CONSTRUCTOR;

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$$8({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR$1 }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    var capabilityReject = capability.reject;
    capabilityReject(r);
    return capability.promise;
  }
});

var anObject$5 = anObject$c;
var isObject$3 = isObject$c;
var newPromiseCapability = newPromiseCapability$2;

var promiseResolve$1 = function (C, x) {
  anObject$5(C);
  if (isObject$3(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var $$7 = _export;
var getBuiltIn = getBuiltIn$7;
var FORCED_PROMISE_CONSTRUCTOR = promiseConstructorDetection.CONSTRUCTOR;
var promiseResolve = promiseResolve$1;

getBuiltIn('Promise');

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$$7({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(this, x);
  }
});

const saveOneAccessTokenResponse$1 = setCookie => accessTokenUserResponse => __awaiter(void 0, void 0, void 0, function* () {
  return new Promise(resolve => {
    setCookie('tolk_access_token', accessTokenUserResponse.accessToken);
    setCookie('tolk_id_token', accessTokenUserResponse.idToken);
    setCookie('tolk_refresh_token', accessTokenUserResponse.refreshToken);
    resolve();
  });
});

const saveOneAccessTokenResponse = setCookie => accessTokenResponse => __awaiter(void 0, void 0, void 0, function* () {
  yield saveOneAccessTokenResponse$1(setCookie)(accessTokenResponse);
});

var index$h = /*#__PURE__*/Object.freeze({
    __proto__: null,
    saveOneAccessTokenResponse: saveOneAccessTokenResponse
});

const saveOnePgApplicationSession = pool => applicationSession => __awaiter(void 0, void 0, void 0, function* () {
  try {
    yield pool.query(`INSERT INTO application_session (
        oauth_client_id,
        refresh_token
    ) VALUES (
      (SELECT "oauth_client".id FROM "oauth_client" WHERE "oauth_client".oauth_client_id = $1),
      $2)
    ON CONFLICT (oauth_client_id) DO UPDATE SET
    refresh_token=$2`, [applicationSession.oAuthClientId, applicationSession.refreshToken]);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
});
const deleteOnePgApplicationSessionByRefreshToken = pool => refreshToken => __awaiter(void 0, void 0, void 0, function* () {
  try {
    yield pool.query(`DELETE FROM application_session WHERE refresh_token = $1;`, [refreshToken]);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
});

const saveOneApplicationSession = pool => applicationSession => __awaiter(void 0, void 0, void 0, function* () {
  yield saveOnePgApplicationSession(pool)(applicationSession);
});
const deleteOneApplicationSessionByRefreshToken = pool => refreshToken => __awaiter(void 0, void 0, void 0, function* () {
  yield deleteOnePgApplicationSessionByRefreshToken(pool)(refreshToken);
});

var index$g = /*#__PURE__*/Object.freeze({
    __proto__: null,
    deleteOneApplicationSessionByRefreshToken: deleteOneApplicationSessionByRefreshToken,
    saveOneApplicationSession: saveOneApplicationSession
});

const getOneRestAccessTokenResponse = axios => (oauthClientId, redirectUri, code, codeVerifier, scopes, nonce) => __awaiter(void 0, void 0, void 0, function* () {
  try {
    const result = yield axios.post(`/v1/token`, {
      code,
      code_verifier: codeVerifier,
      grant_type: 'authorization_code',
      nonce,
      oauth_client_id: oauthClientId,
      redirect_uri: redirectUri,
      scope: scopes
    });
    return result.data;
  } catch (error) {
    if (browserUtils.isAxiosRestError(error)) {
      return null;
    }
    throw genericUtils.sanitizeError(error);
  }
});
const convertRestAccessTokenResponseToAccessTokenUserResponse = restAccessTokenResponse => {
  return {
    accessToken: restAccessTokenResponse.access_token,
    expiresIn: restAccessTokenResponse.expires_in,
    idToken: restAccessTokenResponse.id_token,
    refreshToken: restAccessTokenResponse.refresh_token,
    scope: restAccessTokenResponse.scope,
    tokenType: restAccessTokenResponse.token_type
  };
};

const exchangeAuthorizationCodeWithAccessToken = axios => (oAuthClientId, redirectUri, code, codeVerifier, scopes, nonce) => __awaiter(void 0, void 0, void 0, function* () {
  const result = yield getOneRestAccessTokenResponse(axios)(oAuthClientId, redirectUri, code, codeVerifier, scopes.join(' '), nonce);
  if (result === null) {
    return null;
  }
  return convertRestAccessTokenResponseToAccessTokenUserResponse(result);
});

var index$f = /*#__PURE__*/Object.freeze({
    __proto__: null,
    exchangeAuthorizationCodeWithAccessToken: exchangeAuthorizationCodeWithAccessToken
});

const saveOneLocalAuthorizationInfos = localStorage => localAuthorizationInfos => __awaiter(void 0, void 0, void 0, function* () {
  return new Promise(resolve => {
    localStorage.setItem('tolk_authorization_infos', JSON.stringify(localAuthorizationInfos));
    resolve();
  });
});
const deleteOneLocalAuthorizationInfos = localStorage => () => __awaiter(void 0, void 0, void 0, function* () {
  return new Promise(resolve => {
    localStorage.removeItem('tolk_authorization_infos');
    resolve();
  });
});
const getOneLocalAuthorizationInfos = localStorage => () => __awaiter(void 0, void 0, void 0, function* () {
  return new Promise(resolve => {
    const localAuthorizationInfos = localStorage.getItem('tolk_authorization_infos');
    if (localAuthorizationInfos === null) {
      resolve(null);
      return;
    }
    resolve(JSON.parse(localAuthorizationInfos));
  });
});
const convertAuthorizationInfosToLocalAuhorizationInfos = authorizationInfos => {
  return {
    askedUrl: authorizationInfos.askedUrl,
    codeVerifier: authorizationInfos.codeVerifier,
    loginUrl: authorizationInfos.loginUrl,
    state: authorizationInfos.state
  };
};
const convertLocalAuthorizationInfosToAuhorizationInfos = localAuthorizationInfos => {
  return {
    askedUrl: localAuthorizationInfos.askedUrl,
    codeVerifier: localAuthorizationInfos.codeVerifier,
    loginUrl: localAuthorizationInfos.loginUrl,
    state: localAuthorizationInfos.state
  };
};

const saveOneAuthorizationInfos = localStorage => authorizationInfos => __awaiter(void 0, void 0, void 0, function* () {
  const localAuthorizationInfos = convertAuthorizationInfosToLocalAuhorizationInfos(authorizationInfos);
  yield saveOneLocalAuthorizationInfos(localStorage)(localAuthorizationInfos);
});
const deleteOneAuthorizationInfos = localStorage => () => __awaiter(void 0, void 0, void 0, function* () {
  yield deleteOneLocalAuthorizationInfos(localStorage)();
});
const getOneAuthorizationInfos = localStorage => () => __awaiter(void 0, void 0, void 0, function* () {
  const localAuthorizationInfos = yield getOneLocalAuthorizationInfos(localStorage)();
  if (localAuthorizationInfos === null) {
    return null;
  }
  return convertLocalAuthorizationInfosToAuhorizationInfos(localAuthorizationInfos);
});

var index$e = /*#__PURE__*/Object.freeze({
    __proto__: null,
    deleteOneAuthorizationInfos: deleteOneAuthorizationInfos,
    getOneAuthorizationInfos: getOneAuthorizationInfos,
    saveOneAuthorizationInfos: saveOneAuthorizationInfos
});

const convertPgOauthClientToOauthClient = pgOauthClient => ({
  id: pgOauthClient.oauth_client_id,
  organisationId: pgOauthClient.organisation_id,
  redirectUris: pgOauthClient.redirect_uris,
  secret: pgOauthClient.secret
});
const getOnePgOauthClientById = pool => oAuthClientId => __awaiter(void 0, void 0, void 0, function* () {
  var _a;
  try {
    return (_a = (yield pool.query(`SELECT
              oauth_client.oauth_client_id,
              oauth_client.redirect_uris,
              oauth_client.secret,
              organisation.organisation_id
            FROM oauth_client
            INNER JOIN organisation
            ON oauth_client.organisation_id = organisation.id
            WHERE oauth_client.oauth_client_id = $1`, [oAuthClientId])).rows[genericUtils.ARRAY.FIRST_INDEX]) !== null && _a !== void 0 ? _a : null;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
});

const getOneOauthClientById = pool => oAuthClientId => __awaiter(void 0, void 0, void 0, function* () {
  const pgOauthClient = yield getOnePgOauthClientById(pool)(oAuthClientId);
  if (pgOauthClient === null) {
    return null;
  }
  return convertPgOauthClientToOauthClient(pgOauthClient);
});

var index$d = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getOneOauthClientById: getOneOauthClientById
});

const convertPgOrganisationToOrganisation = pgOrganisation => ({
  id: pgOrganisation.organisation_id,
  url: pgOrganisation.url
});
const getOnePgOrganisationById = pool => organisationId => __awaiter(void 0, void 0, void 0, function* () {
  var _a;
  try {
    return (_a = (yield pool.query('SELECT organisation_id, url FROM organisation WHERE organisation_id = $1', [organisationId])).rows[genericUtils.ARRAY.FIRST_INDEX]) !== null && _a !== void 0 ? _a : null;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
});

const getOneOrganisationById = pool => organisationId => __awaiter(void 0, void 0, void 0, function* () {
  const pgOrganisation = yield getOnePgOrganisationById(pool)(organisationId);
  if (pgOrganisation === null) {
    return null;
  }
  return convertPgOrganisationToOrganisation(pgOrganisation);
});

var index$c = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getOneOrganisationById: getOneOrganisationById
});

var classof$2 = classof$5;

var $String = String;

var toString$3 = function (argument) {
  if (classof$2(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};

// a string of all valid unicode whitespaces
var whitespaces$2 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var uncurryThis$4 = functionUncurryThis;
var requireObjectCoercible$1 = requireObjectCoercible$5;
var toString$2 = toString$3;
var whitespaces$1 = whitespaces$2;

var replace$1 = uncurryThis$4(''.replace);
var ltrim = RegExp('^[' + whitespaces$1 + ']+');
var rtrim = RegExp('(^|[^' + whitespaces$1 + '])[' + whitespaces$1 + ']+$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString$2(requireObjectCoercible$1($this));
    if (TYPE & 1) string = replace$1(string, ltrim, '');
    if (TYPE & 2) string = replace$1(string, rtrim, '$1');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};

var PROPER_FUNCTION_NAME$2 = functionName.PROPER;
var fails$8 = fails$j;
var whitespaces = whitespaces$2;

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
var stringTrimForced = function (METHOD_NAME) {
  return fails$8(function () {
    return !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME$2 && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};

var $$6 = _export;
var $trim = stringTrim.trim;
var forcedStringTrimMethod = stringTrimForced;

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$$6({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});

const comparePassword$1 = bcryptCompare => (password, passwordHash) => __awaiter(void 0, void 0, void 0, function* () {
  try {
    const result = yield bcryptCompare(password.trim(), passwordHash.trim());
    return result;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
});

const comparePassword = bcryptCompare => (password, passwordHash) => __awaiter(void 0, void 0, void 0, function* () {
  return comparePassword$1(bcryptCompare)(password, passwordHash);
});

var index$b = /*#__PURE__*/Object.freeze({
    __proto__: null,
    comparePassword: comparePassword
});

var tryToString = tryToString$5;

var $TypeError$1 = TypeError;

var deletePropertyOrThrow$1 = function (O, P) {
  if (!delete O[P]) throw new $TypeError$1('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
};

var arraySlice = arraySlice$2;

var floor = Math.floor;

var sort = function (array, comparefn) {
  var length = array.length;

  if (length < 8) {
    // insertion sort
    var i = 1;
    var element, j;

    while (i < length) {
      j = i;
      element = array[i];
      while (j && comparefn(array[j - 1], element) > 0) {
        array[j] = array[--j];
      }
      if (j !== i++) array[j] = element;
    }
  } else {
    // merge sort
    var middle = floor(length / 2);
    var left = sort(arraySlice(array, 0, middle), comparefn);
    var right = sort(arraySlice(array, middle), comparefn);
    var llength = left.length;
    var rlength = right.length;
    var lindex = 0;
    var rindex = 0;

    while (lindex < llength || rindex < rlength) {
      array[lindex + rindex] = (lindex < llength && rindex < rlength)
        ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
        : lindex < llength ? left[lindex++] : right[rindex++];
    }
  }

  return array;
};

var arraySort$1 = sort;

var fails$7 = fails$j;

var arrayMethodIsStrict$1 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$7(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};

var userAgent$1 = engineUserAgent;

var firefox = userAgent$1.match(/firefox\/(\d+)/i);

var engineFfVersion = !!firefox && +firefox[1];

var UA = engineUserAgent;

var engineIsIeOrEdge = /MSIE|Trident/.test(UA);

var userAgent = engineUserAgent;

var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);

var engineWebkitVersion = !!webkit && +webkit[1];

var $$5 = _export;
var uncurryThis$3 = functionUncurryThis;
var aCallable = aCallable$9;
var toObject$2 = toObject$4;
var lengthOfArrayLike = lengthOfArrayLike$3;
var deletePropertyOrThrow = deletePropertyOrThrow$1;
var toString$1 = toString$3;
var fails$6 = fails$j;
var internalSort = arraySort$1;
var arrayMethodIsStrict = arrayMethodIsStrict$1;
var FF = engineFfVersion;
var IE_OR_EDGE = engineIsIeOrEdge;
var V8 = engineV8Version;
var WEBKIT = engineWebkitVersion;

var test = [];
var nativeSort = uncurryThis$3(test.sort);
var push$1 = uncurryThis$3(test.push);

// IE8-
var FAILS_ON_UNDEFINED = fails$6(function () {
  test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails$6(function () {
  test.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict('sort');

var STABLE_SORT = !fails$6(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 70;
  if (FF && FF > 3) return;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 603;

  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66: case 69: case 70: case 72: value = 3; break;
      case 68: case 71: value = 4; break;
      default: value = 2;
    }

    for (index = 0; index < 47; index++) {
      test.push({ k: chr + index, v: value });
    }
  }

  test.sort(function (a, b) { return b.v - a.v; });

  for (index = 0; index < test.length; index++) {
    chr = test[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});

var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString$1(x) > toString$1(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$$5({ target: 'Array', proto: true, forced: FORCED }, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable(comparefn);

    var array = toObject$2(this);

    if (STABLE_SORT) return comparefn === undefined ? nativeSort(array) : nativeSort(array, comparefn);

    var items = [];
    var arrayLength = lengthOfArrayLike(array);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) push$1(items, array[index]);
    }

    internalSort(items, getSortCompare(comparefn));

    itemsLength = lengthOfArrayLike(items);
    index = 0;

    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) deletePropertyOrThrow(array, index++);

    return array;
  }
});

var anObject$4 = anObject$c;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags = function () {
  var that = anObject$4(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

var call$3 = functionCall;
var hasOwn$2 = hasOwnProperty_1;
var isPrototypeOf = objectIsPrototypeOf;
var regExpFlags = regexpFlags;

var RegExpPrototype$1 = RegExp.prototype;

var regexpGetFlags = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype$1) && !hasOwn$2(R, 'flags') && isPrototypeOf(RegExpPrototype$1, R)
    ? call$3(regExpFlags, R) : flags;
};

var PROPER_FUNCTION_NAME$1 = functionName.PROPER;
var defineBuiltIn$4 = defineBuiltIn$8;
var anObject$3 = anObject$c;
var $toString$1 = toString$3;
var fails$5 = fails$j;
var getRegExpFlags = regexpGetFlags;

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails$5(function () { return nativeToString.call({ source: 'a', flags: 'b' }) !== '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME$1 && nativeToString.name !== TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn$4(RegExpPrototype, TO_STRING, function toString() {
    var R = anObject$3(this);
    var pattern = $toString$1(R.source);
    var flags = $toString$1(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}

const convertDecodeJwtToAuthorizationCodeContent = jwtAuthorizationCode => ({
  codeChallenge: jwtAuthorizationCode.code_challenge,
  expirationDate: jwtAuthorizationCode.exp,
  id: jwtAuthorizationCode.id,
  oAuthClientId: jwtAuthorizationCode.azp,
  redirectUri: jwtAuthorizationCode.redirect_uri,
  userId: jwtAuthorizationCode.sub
});
const base64UrlEncode = string => encodeURIComponent(Buffer.from(string).toString('base64'));
const sha256 = crypto => string => crypto.createHash('sha256').update(string).digest('hex');
const encodeVerifier = crypto => codeVerifier => base64UrlEncode(sha256(crypto)(codeVerifier));
const isCodeContent = code => {
  const keyCode = ['azp', 'code_challenge', 'exp', 'iat', 'id', 'redirect_uri', 'sub'];
  return genericUtils.isObject(code) &&
  // eslint-disable-next-line functional/immutable-data
  Object.keys(code).sort((valueA, valueB) => valueA.localeCompare(valueB)).every((value, index) => value === keyCode[index]);
};
const isRefreshTokenContent = refreshToken => {
  const keyRefreshToken = ['aud', 'azp', 'exp', 'iat', 'iss', 'nonce', 'scope', 'sub'];
  return genericUtils.isObject(refreshToken) &&
  // eslint-disable-next-line functional/immutable-data
  Object.keys(refreshToken).sort((valueA, valueB) => valueA.localeCompare(valueB)).every((value, index) => value === keyRefreshToken[index]);
};
const isAccessTokenContent = accessToken => {
  const keysAccessToken = ['aud', 'azp', 'exp', 'iat', 'iss', 'nonce', 'scope', 'sub'];
  return genericUtils.isObject(accessToken) &&
  // eslint-disable-next-line functional/immutable-data
  Object.keys(accessToken).sort((valueA, valueB) => valueA.localeCompare(valueB)).every((value, index) => value === keysAccessToken[index]);
};
const generateIssueDateWithExpirateDateAfterFiveMinute = () => {
  const issueDate = Math.floor(Date.now() / genericUtils.TIME.MILLISECONDS_IN_A_SECOND);
  const fiveMinute = genericUtils.TIME.SECONDS_IN_A_MINUTE * genericUtils.NUMBER.FIVE;
  const expirateDate = issueDate + fiveMinute;
  return {
    expirateDate,
    issueDate
  };
};
const generateIssueDateWithExpirateDateAfterOneHour = () => {
  const issueDate = Math.floor(Date.now() / genericUtils.TIME.MILLISECONDS_IN_A_SECOND);
  const expirateDate = issueDate + genericUtils.TIME.SECONDS_IN_AN_HOUR;
  return {
    expirateDate,
    issueDate
  };
};
const generateIssueDateWithExpirateDateAfterOneMonth = () => {
  const issueDate = Math.floor(Date.now() / genericUtils.TIME.MILLISECONDS_IN_A_SECOND);
  const expirateDate = issueDate + genericUtils.TIME.SECONDS_IN_A_MONTH;
  return {
    expirateDate,
    issueDate
  };
};
const convertJwtAccessTokenToAccessTokenInfos = jwtAccessToken => ({
  expirationDate: new Date(jwtAccessToken.exp * genericUtils.TIME.MILLISECONDS_IN_A_SECOND),
  identifiant: jwtAccessToken.sub,
  oAuthClientId: jwtAccessToken.azp,
  scopes: jwtAccessToken.scope.split(','),
  type: jwtAccessToken.nonce === 'app' ? 'app' : 'user'
});

const encodeAuthorizationCode = (jwtSign, jwtSecretKey) => (oauthClientId, redirectUri, codeChallenge, userId) => {
  const jwtSignEncode = {
    azp: oauthClientId,
    code_challenge: codeChallenge,
    id: genericUtils.generateUniqueId(),
    redirect_uri: redirectUri,
    sub: userId
  };
  return jwtSign(jwtSignEncode, jwtSecretKey, {
    expiresIn: genericUtils.TIME.SECONDS_IN_A_MINUTE
  });
};
const decodeAuthorizationCode = (jwtVerify, jwtSecretKey) => code => {
  try {
    const result = jwtVerify(code, jwtSecretKey);
    if (isCodeContent(result)) {
      return convertDecodeJwtToAuthorizationCodeContent(result);
    }
    return null;
  } catch (_a) {
    return null;
  }
};
const validateCodeVerifier = crypto => (codeVerifier, codeChallenge) => {
  return encodeVerifier(crypto)(codeVerifier) === codeChallenge;
};
const encodeAccessTokenUser = jwtSign => (issuer, userId, audienceUrl, oAuthClientId, scope, nonce, secret) => {
  const issueDateWithExpirate = generateIssueDateWithExpirateDateAfterFiveMinute();
  const jwtAccessToken = {
    aud: audienceUrl,
    azp: oAuthClientId,
    exp: issueDateWithExpirate.expirateDate,
    iat: issueDateWithExpirate.issueDate,
    iss: issuer,
    nonce,
    scope,
    sub: userId
  };
  return jwtSign(jwtAccessToken, secret);
};
const encodeAccessTokenApplication = jwtSign => (issuer, audienceUrl, oAuthClientId, scope, secret) => {
  const issueDateWithExpirate = generateIssueDateWithExpirateDateAfterOneHour();
  const jwtAccessToken = {
    aud: audienceUrl,
    azp: oAuthClientId,
    exp: issueDateWithExpirate.expirateDate,
    iat: issueDateWithExpirate.issueDate,
    iss: issuer,
    nonce: 'app',
    scope,
    sub: oAuthClientId
  };
  return jwtSign(jwtAccessToken, secret);
};
const encodeIdToken = jwtSign => (issuer, userId, audienceUrl, oAuthClientId, nonce, scope, firstName, lastName, email, secret, role
// eslint-disable-next-line max-params
) => {
  const issueDateWithExpirate = generateIssueDateWithExpirateDateAfterOneHour();
  const jwtIdToken = {
    aud: audienceUrl,
    azp: oAuthClientId,
    email,
    exp: issueDateWithExpirate.expirateDate,
    family_name: lastName,
    given_name: firstName,
    iat: issueDateWithExpirate.issueDate,
    iss: issuer,
    nonce,
    role,
    scope,
    sub: userId
  };
  return jwtSign(jwtIdToken, secret);
};
const encodeRefreshTokenUser = jwtSign => (issuer, userId, audienceUrl, oAuthClientId, nonce, scope, secret) => {
  const issueDateWithExpirate = generateIssueDateWithExpirateDateAfterOneHour();
  const jwtRefreshToken = {
    aud: audienceUrl,
    azp: oAuthClientId,
    exp: issueDateWithExpirate.expirateDate,
    iat: issueDateWithExpirate.issueDate,
    iss: issuer,
    nonce,
    scope,
    sub: userId
  };
  return jwtSign(jwtRefreshToken, secret);
};
const encodeRefreshTokenApplication = jwtSign => (issuer, audienceUrl, oAuthClientId, scope, secret) => {
  const issueDateWithExpirate = generateIssueDateWithExpirateDateAfterOneMonth();
  const jwtRefreshToken = {
    aud: audienceUrl,
    azp: oAuthClientId,
    exp: issueDateWithExpirate.expirateDate,
    iat: issueDateWithExpirate.issueDate,
    iss: issuer,
    nonce: 'app',
    scope,
    sub: oAuthClientId
  };
  return jwtSign(jwtRefreshToken, secret);
};
const decodeRefreshToken = jwtVerify => (refreshToken, secret) => {
  try {
    const result = jwtVerify(refreshToken, secret);
    if (!isRefreshTokenContent(result)) {
      return null;
    }
    return result;
  } catch (_a) {
    return null;
  }
};
const verifyAccessToken = (jwtVerify, authManagementBaseUrl) => (accessToken, secret, audience) => {
  try {
    const verify = {
      audience,
      authManagementBaseUrl
    };
    const result = jwtVerify(accessToken, secret, verify);
    if (!isAccessTokenContent(result)) {
      return false;
    }
    return true;
  } catch (_a) {
    return false;
  }
};
const decodeAccessToken = jwtDecode => accessToken => {
  try {
    const result = jwtDecode(accessToken);
    if (!isAccessTokenContent(result)) {
      return null;
    }
    return convertJwtAccessTokenToAccessTokenInfos(result);
  } catch (_a) {
    return null;
  }
};

var index$a = /*#__PURE__*/Object.freeze({
    __proto__: null,
    decodeAccessToken: decodeAccessToken,
    decodeAuthorizationCode: decodeAuthorizationCode,
    decodeRefreshToken: decodeRefreshToken,
    encodeAccessTokenApplication: encodeAccessTokenApplication,
    encodeAccessTokenUser: encodeAccessTokenUser,
    encodeAuthorizationCode: encodeAuthorizationCode,
    encodeIdToken: encodeIdToken,
    encodeRefreshTokenApplication: encodeRefreshTokenApplication,
    encodeRefreshTokenUser: encodeRefreshTokenUser,
    validateCodeVerifier: validateCodeVerifier,
    verifyAccessToken: verifyAccessToken
});

const convertPgUserSessionToUserSession = pgUserSession => ({
  oAuthClientId: pgUserSession.oauth_client_id,
  refreshToken: pgUserSession.refresh_token,
  userId: pgUserSession.user_id
});
const saveOnePgUserSession = pool => userSession => __awaiter(void 0, void 0, void 0, function* () {
  try {
    yield pool.query(`INSERT INTO user_session (
        user_id,
        oauth_client_id,
        refresh_token
    ) VALUES (
      (SELECT "user".id FROM "user" WHERE "user".user_id = $1),
      (SELECT "oauth_client".id FROM "oauth_client" WHERE "oauth_client".oauth_client_id = $2),
      $3)
    ON CONFLICT (user_id) DO UPDATE SET
    oauth_client_id=(SELECT "oauth_client".id FROM "oauth_client" WHERE "oauth_client".oauth_client_id = $2),
    refresh_token=$3`, [userSession.userId, userSession.oAuthClientId, userSession.refreshToken]);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
});
const getOnePgUserSessionByRefreshToken = pool => refreshToken => __awaiter(void 0, void 0, void 0, function* () {
  var _a;
  try {
    return (_a = (yield pool.query(`SELECT
            "user".user_id,
            "oauth_client".oauth_client_id,
            refresh_token
          FROM user_session
          INNER JOIN "user" ON "user".id = user_session.user_id
          INNER JOIN "oauth_client" ON "oauth_client".id = user_session.oauth_client_id
          WHERE refresh_token = $1`, [refreshToken])).rows[genericUtils.ARRAY.FIRST_INDEX]) !== null && _a !== void 0 ? _a : null;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
});
const deleteOnePgUserSessionByRefreshToken = pool => refreshToken => __awaiter(void 0, void 0, void 0, function* () {
  try {
    yield pool.query(`DELETE FROM user_session WHERE refresh_token = $1;`, [refreshToken]);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
});

const saveOneUserSession = pool => userSession => __awaiter(void 0, void 0, void 0, function* () {
  yield saveOnePgUserSession(pool)(userSession);
});
const getOneUserSessionByRefreshToken = pool => refreshToken => __awaiter(void 0, void 0, void 0, function* () {
  try {
    const pgUserSession = yield getOnePgUserSessionByRefreshToken(pool)(refreshToken);
    if (pgUserSession === null) {
      return null;
    }
    return convertPgUserSessionToUserSession(pgUserSession);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
});
const deleteOneUserSessionByRefreshToken = pool => refreshToken => __awaiter(void 0, void 0, void 0, function* () {
  yield deleteOnePgUserSessionByRefreshToken(pool)(refreshToken);
});

var index$9 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    deleteOneUserSessionByRefreshToken: deleteOneUserSessionByRefreshToken,
    getOneUserSessionByRefreshToken: getOneUserSessionByRefreshToken,
    saveOneUserSession: saveOneUserSession
});

const convertPgUserToUser = (pgUser, userPermission) => ({
  active: pgUser.active,
  createDate: new Date(pgUser.create_date),
  email: pgUser.email,
  firstName: pgUser.first_name,
  id: pgUser.user_id,
  jobTitle: pgUser.job_title,
  lastName: pgUser.last_name,
  passwordHash: pgUser.password_hash,
  role: userPermission,
  termsCheck: pgUser.terms_check
});
const getOnePgUserByEmail = pool => email => __awaiter(void 0, void 0, void 0, function* () {
  var _a;
  try {
    return (_a = (yield pool.query(`SELECT
              "user".user_id,
              "user".email,
              "user".password_hash,
              "user".active,
              "user".create_date,
              "user_profile".first_name,
              "user_profile".job_title,
              "user_profile".last_name,
              "user_profile".terms_check
           FROM "user"
           INNER JOIN user_profile ON user_profile.user_id = "user".id
           WHERE "user".email = $1`, [email])).rows[genericUtils.ARRAY.FIRST_INDEX]) !== null && _a !== void 0 ? _a : null;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
});
const getOnePgUserById = pool => userId => __awaiter(void 0, void 0, void 0, function* () {
  var _b;
  try {
    return (_b = (yield pool.query(`SELECT
              "user".user_id,
              email,
              password_hash,
              "user".active,
              "user".create_date,
              "user_profile".first_name,
              "user_profile".job_title,
              "user_profile".last_name,
              "user_profile".terms_check
          FROM "user"
          INNER JOIN user_profile ON user_profile.user_id = "user".id
          WHERE "user".user_id = $1`, [userId])).rows[genericUtils.ARRAY.FIRST_INDEX]) !== null && _b !== void 0 ? _b : null;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
});
const getOneUserPermissionsByUserId = (authenticatedApplicationRequest, tolkManagementExpressBaseUrl) => userId => __awaiter(void 0, void 0, void 0, function* () {
  try {
    const restUserPermission = yield authenticatedApplicationRequest('get', `${tolkManagementExpressBaseUrl}/v1/users/${userId}/permissions`);
    return restUserPermission;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
});

const getOneUserByEmail = (pool, authenticatedApplicationRequest, tolkManagementExpressBaseUrl) => email => __awaiter(void 0, void 0, void 0, function* () {
  const pgUser = yield getOnePgUserByEmail(pool)(email);
  if (pgUser === null) {
    return null;
  }
  const userPermission = yield getOneUserPermissionsByUserId(authenticatedApplicationRequest, tolkManagementExpressBaseUrl)(pgUser.user_id);
  return convertPgUserToUser(pgUser, userPermission);
});
const getOneUserById = (pool, authenticatedApplicationRequest, tolkManagementExpressBaseUrl) => userId => __awaiter(void 0, void 0, void 0, function* () {
  const pgUser = yield getOnePgUserById(pool)(userId);
  if (pgUser === null) {
    return null;
  }
  const userPermission = yield getOneUserPermissionsByUserId(authenticatedApplicationRequest, tolkManagementExpressBaseUrl)(pgUser.user_id);
  return convertPgUserToUser(pgUser, userPermission);
});

var index$8 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getOneUserByEmail: getOneUserByEmail,
    getOneUserById: getOneUserById
});

var $schema = "http://json-schema.org/draft-07/schema#";
var definitions = {
	AuthorizationInfosState: {
		type: "string"
	},
	AuthorizationInfos: {
		type: "object",
		properties: {
			codeVerifier: {
				type: "string"
			},
			state: {
				type: "string"
			},
			loginUrl: {
				type: "string"
			},
			askedUrl: {
				type: "string"
			}
		},
		required: [
			"codeVerifier",
			"state",
			"loginUrl",
			"askedUrl"
		],
		additionalProperties: false
	},
	State: {
		type: "string"
	},
	Code: {
		type: "string"
	},
	AuthorizationResponse: {
		type: "object",
		properties: {
			code: {
				$ref: "#/definitions/Code"
			},
			state: {
				$ref: "#/definitions/State"
			}
		},
		required: [
			"code",
			"state"
		],
		additionalProperties: false
	},
	UserRole: {
		type: "string",
		"enum": [
			"tolk-admin",
			"tolk-super-admin",
			"tolk-user"
		]
	},
	UserId: {
		type: "string"
	},
	UserEmail: {
		type: "string"
	},
	UserPasswordHash: {
		type: "string"
	},
	UserPassword: {
		type: "string"
	},
	JobTitle: {
		type: "string",
		"enum": [
			"admin-ops",
			"customer support",
			"marketing",
			"other",
			"sales"
		]
	},
	UserFirstName: {
		type: "string"
	},
	UserLastName: {
		type: "string"
	},
	User: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/UserId"
			},
			email: {
				$ref: "#/definitions/UserEmail"
			},
			passwordHash: {
				$ref: "#/definitions/UserPasswordHash"
			},
			firstName: {
				$ref: "#/definitions/UserFirstName"
			},
			lastName: {
				$ref: "#/definitions/UserLastName"
			},
			jobTitle: {
				$ref: "#/definitions/JobTitle"
			},
			role: {
				$ref: "#/definitions/UserRole"
			},
			active: {
				type: "boolean"
			},
			createDate: {
				type: "string",
				format: "date-time"
			},
			termsCheck: {
				type: "boolean"
			}
		},
		required: [
			"id",
			"email",
			"passwordHash",
			"firstName",
			"lastName",
			"jobTitle",
			"role",
			"active",
			"createDate",
			"termsCheck"
		],
		additionalProperties: false
	},
	UserSession: {
		type: "object",
		properties: {
			userId: {
				$ref: "#/definitions/UserId"
			},
			oAuthClientId: {
				$ref: "#/definitions/OauthClientId"
			},
			refreshToken: {
				$ref: "#/definitions/RefreshToken"
			}
		},
		required: [
			"userId",
			"oAuthClientId",
			"refreshToken"
		],
		additionalProperties: false
	},
	OauthClientId: {
		type: "string"
	},
	RefreshToken: {
		type: "string"
	},
	CodeChallenge: {
		type: "string"
	},
	AuthorizationCodeContent: {
		type: "object",
		properties: {
			id: {
				type: "string"
			},
			oAuthClientId: {
				$ref: "#/definitions/OauthClientId"
			},
			redirectUri: {
				$ref: "#/definitions/RedirectUri"
			},
			userId: {
				$ref: "#/definitions/UserId"
			},
			codeChallenge: {
				$ref: "#/definitions/CodeChallenge"
			},
			expirationDate: {
				type: "number"
			}
		},
		required: [
			"id",
			"oAuthClientId",
			"redirectUri",
			"userId",
			"codeChallenge",
			"expirationDate"
		],
		additionalProperties: false
	},
	RedirectUri: {
		type: "string"
	},
	OrganisationId: {
		type: "string"
	},
	OrganisationUrl: {
		type: "string"
	},
	Organisation: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/OrganisationId"
			},
			url: {
				$ref: "#/definitions/OrganisationUrl"
			}
		},
		required: [
			"id",
			"url"
		],
		additionalProperties: false
	},
	RefreshTokenContentBase: {
		type: "object",
		properties: {
			azp: {
				type: "string"
			},
			iss: {
				type: "string"
			},
			sub: {
				type: "string"
			},
			aud: {
				type: "string"
			},
			iat: {
				type: "number"
			},
			scope: {
				type: "string"
			},
			exp: {
				type: "number"
			}
		},
		required: [
			"azp",
			"iss",
			"sub",
			"aud",
			"iat",
			"scope",
			"exp"
		],
		additionalProperties: false
	},
	RefreshTokenContentUser: {
		type: "object",
		additionalProperties: false,
		properties: {
			nonce: {
				type: "string"
			},
			azp: {
				type: "string"
			},
			iss: {
				type: "string"
			},
			sub: {
				type: "string"
			},
			aud: {
				type: "string"
			},
			iat: {
				type: "number"
			},
			scope: {
				type: "string"
			},
			exp: {
				type: "number"
			}
		},
		required: [
			"aud",
			"azp",
			"exp",
			"iat",
			"iss",
			"nonce",
			"scope",
			"sub"
		]
	},
	RefreshTokenContentApplication: {
		type: "object",
		additionalProperties: false,
		properties: {
			nonce: {
				type: "string",
				"const": "app"
			},
			azp: {
				type: "string"
			},
			iss: {
				type: "string"
			},
			sub: {
				type: "string"
			},
			aud: {
				type: "string"
			},
			iat: {
				type: "number"
			},
			scope: {
				type: "string"
			},
			exp: {
				type: "number"
			}
		},
		required: [
			"aud",
			"azp",
			"exp",
			"iat",
			"iss",
			"nonce",
			"scope",
			"sub"
		]
	},
	RefreshTokenContent: {
		anyOf: [
			{
				$ref: "#/definitions/RefreshTokenContentApplication"
			},
			{
				$ref: "#/definitions/RefreshTokenContentUser"
			}
		]
	},
	TokenType: {
		type: "string",
		"const": "bearer"
	},
	AccessToken: {
		type: "string"
	},
	Nonce: {
		type: "string"
	},
	Scope: {
		type: "string"
	},
	Scopes: {
		type: "array",
		items: {
			$ref: "#/definitions/Scope"
		}
	},
	Issuer: {
		type: "string"
	},
	AudienceUrl: {
		type: "string"
	},
	AccessTokenBase: {
		type: "object",
		properties: {
			accessToken: {
				type: "string"
			},
			refreshToken: {
				$ref: "#/definitions/RefreshToken"
			},
			scope: {
				$ref: "#/definitions/Scope"
			},
			tokenType: {
				$ref: "#/definitions/TokenType"
			},
			expiresIn: {
				type: "number",
				"const": 3600
			}
		},
		required: [
			"accessToken",
			"refreshToken",
			"scope",
			"tokenType",
			"expiresIn"
		],
		additionalProperties: false
	},
	AccessTokenUserResponse: {
		type: "object",
		additionalProperties: false,
		properties: {
			idToken: {
				type: "string"
			},
			accessToken: {
				type: "string"
			},
			refreshToken: {
				$ref: "#/definitions/RefreshToken"
			},
			scope: {
				$ref: "#/definitions/Scope"
			},
			tokenType: {
				$ref: "#/definitions/TokenType"
			},
			expiresIn: {
				type: "number",
				"const": 3600
			}
		},
		required: [
			"accessToken",
			"expiresIn",
			"idToken",
			"refreshToken",
			"scope",
			"tokenType"
		]
	},
	AccessTokenApplicationResponse: {
		$ref: "#/definitions/AccessTokenBase"
	},
	OauthClientSecret: {
		type: "string"
	},
	CodeVerifier: {
		type: "string"
	},
	OauthClient: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/OauthClientId"
			},
			secret: {
				$ref: "#/definitions/OauthClientSecret"
			},
			redirectUris: {
				type: "array",
				items: {
					$ref: "#/definitions/RedirectUri"
				}
			},
			organisationId: {
				$ref: "#/definitions/OrganisationId"
			}
		},
		required: [
			"id",
			"secret",
			"redirectUris",
			"organisationId"
		],
		additionalProperties: false
	},
	ApplicationSession: {
		type: "object",
		properties: {
			oAuthClientId: {
				$ref: "#/definitions/OauthClientId"
			},
			refreshToken: {
				$ref: "#/definitions/RefreshToken"
			}
		},
		required: [
			"oAuthClientId",
			"refreshToken"
		],
		additionalProperties: false
	},
	AccessTokenInfos: {
		type: "object",
		properties: {
			oAuthClientId: {
				$ref: "#/definitions/OauthClientId"
			},
			expirationDate: {
				type: "string",
				format: "date-time"
			},
			scopes: {
				type: "array",
				items: {
					type: "string"
				}
			},
			type: {
				type: "string",
				"enum": [
					"app",
					"user"
				]
			},
			identifiant: {
				type: "string"
			}
		},
		required: [
			"oAuthClientId",
			"expirationDate",
			"scopes",
			"type",
			"identifiant"
		],
		additionalProperties: false
	},
	RefreshTokenBase: {
		type: "object",
		properties: {
			accessToken: {
				type: "string"
			},
			refreshToken: {
				$ref: "#/definitions/RefreshToken"
			},
			scope: {
				$ref: "#/definitions/Scope"
			},
			tokenType: {
				$ref: "#/definitions/TokenType"
			},
			expiresIn: {
				type: "number",
				"const": 3600
			}
		},
		required: [
			"accessToken",
			"refreshToken",
			"scope",
			"tokenType",
			"expiresIn"
		],
		additionalProperties: false
	},
	RefreshTokenUserResponse: {
		type: "object",
		additionalProperties: false,
		properties: {
			idToken: {
				type: "string"
			},
			accessToken: {
				type: "string"
			},
			refreshToken: {
				$ref: "#/definitions/RefreshToken"
			},
			scope: {
				$ref: "#/definitions/Scope"
			},
			tokenType: {
				$ref: "#/definitions/TokenType"
			},
			expiresIn: {
				type: "number",
				"const": 3600
			}
		},
		required: [
			"accessToken",
			"expiresIn",
			"idToken",
			"refreshToken",
			"scope",
			"tokenType"
		]
	},
	RefreshTokenApplicationResponse: {
		$ref: "#/definitions/RefreshTokenBase"
	},
	CookiesAccessTokenResponse: {
		type: "object",
		properties: {
			accessToken: {
				type: "string"
			},
			refreshToken: {
				type: "string"
			},
			idToken: {
				type: "string"
			},
			scope: {
				type: "string"
			},
			tokenType: {
				type: "string",
				"const": "bearer"
			},
			expiresIn: {
				type: "number",
				"const": 3600
			}
		},
		required: [
			"accessToken",
			"refreshToken",
			"idToken",
			"scope",
			"tokenType",
			"expiresIn"
		],
		additionalProperties: false
	},
	PgApplicationSession: {
		type: "object",
		properties: {
			oauth_client_id: {
				type: "string"
			},
			refresh_token: {
				type: "string"
			}
		},
		required: [
			"oauth_client_id",
			"refresh_token"
		],
		additionalProperties: false
	},
	RestAuthorizationCodeRequest: {
		type: "object",
		properties: {
			grant_type: {
				type: "string",
				"const": "authorization_code"
			},
			code: {
				type: "string"
			},
			redirect_uri: {
				type: "string"
			},
			nonce: {
				type: "string"
			},
			oauth_client_id: {
				type: "string"
			},
			scopes: {
				type: "array",
				items: {
					type: "string"
				}
			},
			code_verifier: {
				type: "string"
			}
		},
		required: [
			"grant_type",
			"code",
			"redirect_uri",
			"nonce",
			"oauth_client_id",
			"scopes",
			"code_verifier"
		],
		additionalProperties: false
	},
	RestAccessTokenResponse: {
		type: "object",
		properties: {
			access_token: {
				type: "string"
			},
			refresh_token: {
				type: "string"
			},
			id_token: {
				type: "string"
			},
			scope: {
				type: "string"
			},
			token_type: {
				type: "string",
				"const": "bearer"
			},
			expires_in: {
				type: "number"
			}
		},
		required: [
			"access_token",
			"refresh_token",
			"id_token",
			"scope",
			"token_type",
			"expires_in"
		],
		additionalProperties: false
	},
	LocalAuthorizationInfos: {
		type: "object",
		properties: {
			codeVerifier: {
				type: "string"
			},
			state: {
				type: "string"
			},
			loginUrl: {
				type: "string"
			},
			askedUrl: {
				type: "string"
			}
		},
		required: [
			"codeVerifier",
			"state",
			"loginUrl",
			"askedUrl"
		],
		additionalProperties: false
	},
	PgOauthClient: {
		type: "object",
		properties: {
			redirect_uris: {
				type: "array",
				items: {
					type: "string"
				}
			},
			oauth_client_id: {
				type: "string"
			},
			secret: {
				type: "string"
			},
			organisation_id: {
				type: "string"
			}
		},
		required: [
			"redirect_uris",
			"oauth_client_id",
			"secret",
			"organisation_id"
		],
		additionalProperties: false
	},
	PgOrganisation: {
		type: "object",
		properties: {
			organisation_id: {
				type: "string"
			},
			url: {
				type: "string"
			}
		},
		required: [
			"organisation_id",
			"url"
		],
		additionalProperties: false
	},
	PgUserSession: {
		type: "object",
		properties: {
			user_id: {
				type: "string"
			},
			oauth_client_id: {
				type: "string"
			},
			refresh_token: {
				type: "string"
			}
		},
		required: [
			"user_id",
			"oauth_client_id",
			"refresh_token"
		],
		additionalProperties: false
	},
	JwtSecretKey: {
		type: "string"
	},
	JwtAuthorizationCode: {
		type: "object",
		properties: {
			id: {
				type: "string"
			},
			azp: {
				$ref: "#/definitions/OauthClientId"
			},
			code_challenge: {
				$ref: "#/definitions/CodeChallenge"
			},
			redirect_uri: {
				$ref: "#/definitions/RedirectUri"
			},
			sub: {
				$ref: "#/definitions/UserId"
			},
			exp: {
				type: "number"
			},
			iat: {
				type: "number"
			}
		},
		required: [
			"id",
			"azp",
			"code_challenge",
			"redirect_uri",
			"sub",
			"exp",
			"iat"
		],
		additionalProperties: false
	},
	JwtAccessToken: {
		type: "object",
		properties: {
			iss: {
				type: "string"
			},
			sub: {
				type: "string"
			},
			aud: {
				type: "string"
			},
			iat: {
				type: "number"
			},
			exp: {
				type: "number"
			},
			nonce: {
				type: "string"
			},
			scope: {
				type: "string"
			},
			azp: {
				type: "string"
			}
		},
		required: [
			"iss",
			"sub",
			"aud",
			"iat",
			"exp",
			"nonce",
			"scope",
			"azp"
		],
		additionalProperties: false
	},
	JwtIdToken: {
		type: "object",
		additionalProperties: false,
		properties: {
			email: {
				type: "string"
			},
			given_name: {
				type: "string"
			},
			family_name: {
				type: "string"
			},
			role: {
				$ref: "#/definitions/UserRole"
			},
			iss: {
				type: "string"
			},
			sub: {
				type: "string"
			},
			aud: {
				type: "string"
			},
			iat: {
				type: "number"
			},
			exp: {
				type: "number"
			},
			nonce: {
				type: "string"
			},
			scope: {
				type: "string"
			},
			azp: {
				type: "string"
			}
		},
		required: [
			"aud",
			"azp",
			"email",
			"exp",
			"family_name",
			"given_name",
			"iat",
			"iss",
			"nonce",
			"role",
			"scope",
			"sub"
		]
	},
	JwtRefreshToken: {
		type: "object",
		properties: {
			azp: {
				type: "string"
			},
			iss: {
				type: "string"
			},
			sub: {
				type: "string"
			},
			aud: {
				type: "string"
			},
			nonce: {
				type: "string"
			},
			iat: {
				type: "number"
			},
			exp: {
				type: "number"
			},
			scope: {
				type: "string"
			}
		},
		required: [
			"azp",
			"iss",
			"sub",
			"aud",
			"nonce",
			"iat",
			"exp",
			"scope"
		],
		additionalProperties: false
	},
	PgJobTitle: {
		type: "string",
		"enum": [
			"admin-ops",
			"customer support",
			"marketing",
			"other",
			"sales"
		]
	},
	PgUser: {
		type: "object",
		properties: {
			active: {
				type: "boolean"
			},
			create_date: {
				type: "string"
			},
			user_id: {
				type: "string"
			},
			email: {
				type: "string"
			},
			password_hash: {
				type: "string"
			},
			first_name: {
				type: "string"
			},
			job_title: {
				$ref: "#/definitions/PgJobTitle"
			},
			last_name: {
				type: "string"
			},
			terms_check: {
				type: "boolean"
			}
		},
		required: [
			"active",
			"create_date",
			"user_id",
			"email",
			"password_hash",
			"first_name",
			"job_title",
			"last_name",
			"terms_check"
		],
		additionalProperties: false
	},
	RestUserPermission: {
		type: "string",
		"enum": [
			"tolk-admin",
			"tolk-super-admin",
			"tolk-user"
		]
	}
};
var entitiesSchemas = {
	$schema: $schema,
	definitions: definitions
};

var entitiesSchemas$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    $schema: $schema,
    definitions: definitions,
    'default': entitiesSchemas
});

var objectDefineProperties = {};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$4 = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule = objectDefineProperty;
var anObject$2 = anObject$c;
var toIndexedObject$1 = toIndexedObject$5;
var objectKeys$1 = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$4 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$2(O);
  var props = toIndexedObject$1(Properties);
  var keys = objectKeys$1(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};

/* global ActiveXObject -- old IE, WSH */
var anObject$1 = anObject$c;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html = html$2;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$1 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$1('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$1(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var wellKnownSymbol$7 = wellKnownSymbol$i;
var create$2 = objectCreate;
var defineProperty$2 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol$7('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] === undefined) {
  defineProperty$2(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create$2(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$2 = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var fails$4 = fails$j;

var correctPrototypeGetter = !fails$4(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var hasOwn$1 = hasOwnProperty_1;
var isCallable$3 = isCallable$k;
var toObject$1 = toObject$4;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject$1(O);
  if (hasOwn$1(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$3(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};

var fails$3 = fails$j;
var isCallable$2 = isCallable$k;
var isObject$2 = isObject$c;
var getPrototypeOf$1 = objectGetPrototypeOf;
var defineBuiltIn$3 = defineBuiltIn$8;
var wellKnownSymbol$6 = wellKnownSymbol$i;

var ITERATOR$4 = wellKnownSymbol$6('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject$2(IteratorPrototype$2) || fails$3(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$4].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$2(IteratorPrototype$2[ITERATOR$4])) {
  defineBuiltIn$3(IteratorPrototype$2, ITERATOR$4, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create$1 = objectCreate;
var createPropertyDescriptor$1 = createPropertyDescriptor$4;
var setToStringTag$3 = setToStringTag$5;
var Iterators$2 = iterators;

var returnThis$1 = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create$1(IteratorPrototype$1, { next: createPropertyDescriptor$1(+!ENUMERABLE_NEXT, next) });
  setToStringTag$3(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$2[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var $$4 = _export;
var call$2 = functionCall;
var FunctionName = functionName;
var isCallable$1 = isCallable$k;
var createIteratorConstructor$1 = iteratorCreateConstructor;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag$2 = setToStringTag$5;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$4;
var defineBuiltIn$2 = defineBuiltIn$8;
var wellKnownSymbol$5 = wellKnownSymbol$i;
var Iterators$1 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$3 = wellKnownSymbol$5('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor$1(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    }

    return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$3]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$1(CurrentIteratorPrototype[ITERATOR$3])) {
          defineBuiltIn$2(CurrentIteratorPrototype, ITERATOR$3, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$2(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$1(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$2(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn$2(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$4({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$3] !== defaultIterator) {
    defineBuiltIn$2(IterablePrototype, ITERATOR$3, defaultIterator, { name: DEFAULT });
  }
  Iterators$1[NAME] = defaultIterator;

  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject$2 = function (value, done) {
  return { value: value, done: done };
};

var toIndexedObject = toIndexedObject$5;
var addToUnscopables$1 = addToUnscopables$2;
var Iterators = iterators;
var InternalStateModule$1 = internalState;
var defineProperty$1 = objectDefineProperty.f;
var defineIterator = iteratorDefine;
var createIterResultObject$1 = createIterResultObject$2;
var DESCRIPTORS$3 = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$1 = InternalStateModule$1.set;
var getInternalState = InternalStateModule$1.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState$1(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject$1(undefined, true);
  }
  switch (state.kind) {
    case 'keys': return createIterResultObject$1(index, false);
    case 'values': return createIterResultObject$1(target[index], false);
  } return createIterResultObject$1([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('keys');
addToUnscopables$1('values');
addToUnscopables$1('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$3 && values.name !== 'values') try {
  defineProperty$1(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

var DESCRIPTORS$2 = descriptors;
var uncurryThis$2 = functionUncurryThis;
var call$1 = functionCall;
var fails$2 = fails$j;
var objectKeys = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject = toObject$4;
var IndexedObject = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis$2([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$2(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$2 && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol('assign detection');
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$2 || call$1(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$3 = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$3({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var global$2 = global$j;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty = createNonEnumerableProperty$4;
var setToStringTag$1 = setToStringTag$5;
var wellKnownSymbol$4 = wellKnownSymbol$i;

var ITERATOR$2 = wellKnownSymbol$4('iterator');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$2] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR$2, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$2] = ArrayValues;
    }
    setToStringTag$1(CollectionPrototype, COLLECTION_NAME, true);
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$2[COLLECTION_NAME] && global$2[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

const accessTokenUserResponseFactory = (encodeAccessTokenUser, encodeIdToken, encodeRefreshTokenUser) => (issuer, nonce, scopes, user, oauthClientId, audienceUrl, secret) => {
  const scopesString = scopes.join(' ');
  const accessToken = encodeAccessTokenUser(issuer, user.id, audienceUrl, oauthClientId, scopesString, nonce, secret);
  const idToken = encodeIdToken(issuer, user.id, audienceUrl, oauthClientId, nonce, scopesString, user.firstName, user.lastName, user.email, secret, user.role);
  const refreshToken = encodeRefreshTokenUser(issuer, user.id, audienceUrl, oauthClientId, nonce, scopesString, secret);
  return {
    accessToken,
    expiresIn: genericUtils.TIME.SECONDS_IN_AN_HOUR,
    idToken,
    refreshToken,
    scope: scopesString,
    tokenType: 'bearer'
  };
};
const accessTokenApplicationResponseFactory = (encodeAccessTokenApplication, encodeRefreshTokenApplication) => (issuer, scopes, oauthClientId, audienceUrl, secret) => {
  const scopesString = scopes.join(' ');
  const accessToken = encodeAccessTokenApplication(issuer, audienceUrl, oauthClientId, scopesString, secret);
  const refreshToken = encodeRefreshTokenApplication(issuer, audienceUrl, oauthClientId, scopesString, secret);
  return {
    accessToken,
    expiresIn: genericUtils.TIME.SECONDS_IN_AN_HOUR,
    refreshToken,
    scope: scopesString,
    tokenType: 'bearer'
  };
};

var index$7 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    accessTokenApplicationResponseFactory: accessTokenApplicationResponseFactory,
    accessTokenUserResponseFactory: accessTokenUserResponseFactory
});

var fails$1 = fails$j;
var wellKnownSymbol$3 = wellKnownSymbol$i;
var DESCRIPTORS$1 = descriptors;
var IS_PURE = isPure;

var ITERATOR$1 = wellKnownSymbol$3('iterator');

var urlConstructorDetection = !fails$1(function () {
  // eslint-disable-next-line unicorn/relative-url-style -- required for testing
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var params = url.searchParams;
  var params2 = new URLSearchParams('a=1&a=2&b=3');
  var result = '';
  url.pathname = 'c%20d';
  params.forEach(function (value, key) {
    params['delete']('b');
    result += key + value;
  });
  params2['delete']('a', 2);
  // `undefined` case is a Chromium 117 bug
  // https://bugs.chromium.org/p/v8/issues/detail?id=14222
  params2['delete']('b', undefined);
  return (IS_PURE && (!url.toJSON || !params2.has('a', 1) || params2.has('a', 2) || !params2.has('a', undefined) || params2.has('b')))
    || (!params.size && (IS_PURE || !DESCRIPTORS$1))
    || !params.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || params.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !params[ITERATOR$1]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});

var defineBuiltIn$1 = defineBuiltIn$8;

var defineBuiltIns$1 = function (target, src, options) {
  for (var key in src) defineBuiltIn$1(target, key, src[key], options);
  return target;
};

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`

var $$2 = _export;
var global$1 = global$j;
var safeGetBuiltIn = safeGetBuiltIn$2;
var call = functionCall;
var uncurryThis$1 = functionUncurryThis;
var DESCRIPTORS = descriptors;
var USE_NATIVE_URL = urlConstructorDetection;
var defineBuiltIn = defineBuiltIn$8;
var defineBuiltInAccessor = defineBuiltInAccessor$2;
var defineBuiltIns = defineBuiltIns$1;
var setToStringTag = setToStringTag$5;
var createIteratorConstructor = iteratorCreateConstructor;
var InternalStateModule = internalState;
var anInstance = anInstance$2;
var isCallable = isCallable$k;
var hasOwn = hasOwnProperty_1;
var bind = functionBindContext;
var classof$1 = classof$5;
var anObject = anObject$c;
var isObject$1 = isObject$c;
var $toString = toString$3;
var create = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$4;
var getIterator = getIterator$2;
var getIteratorMethod = getIteratorMethod$3;
var createIterResultObject = createIterResultObject$2;
var validateArgumentsLength = validateArgumentsLength$2;
var wellKnownSymbol$2 = wellKnownSymbol$i;
var arraySort = arraySort$1;

var ITERATOR = wellKnownSymbol$2('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState = InternalStateModule.set;
var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);

var nativeFetch = safeGetBuiltIn('fetch');
var NativeRequest = safeGetBuiltIn('Request');
var Headers = safeGetBuiltIn('Headers');
var RequestPrototype = NativeRequest && NativeRequest.prototype;
var HeadersPrototype = Headers && Headers.prototype;
var RegExp$1 = global$1.RegExp;
var TypeError$1 = global$1.TypeError;
var decodeURIComponent = global$1.decodeURIComponent;
var encodeURIComponent$1 = global$1.encodeURIComponent;
var charAt = uncurryThis$1(''.charAt);
var join = uncurryThis$1([].join);
var push = uncurryThis$1([].push);
var replace = uncurryThis$1(''.replace);
var shift = uncurryThis$1([].shift);
var splice = uncurryThis$1([].splice);
var split = uncurryThis$1(''.split);
var stringSlice = uncurryThis$1(''.slice);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp$1('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = replace(it, plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = replace(result, percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find = /[!'()~]|%20/g;

var replacements = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replacements[match];
};

var serialize = function (it) {
  return replace(encodeURIComponent$1(it), find, replacer);
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    target: getInternalParamsState(params).entries,
    index: 0,
    kind: kind
  });
}, URL_SEARCH_PARAMS, function next() {
  var state = getInternalIteratorState(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  var entry = target[index];
  switch (state.kind) {
    case 'keys': return createIterResultObject(entry.key, false);
    case 'values': return createIterResultObject(entry.value, false);
  } return createIterResultObject([entry.key, entry.value], false);
}, true);

var URLSearchParamsState = function (init) {
  this.entries = [];
  this.url = null;

  if (init !== undefined) {
    if (isObject$1(init)) this.parseObject(init);
    else this.parseQuery(typeof init == 'string' ? charAt(init, 0) === '?' ? stringSlice(init, 1) : init : $toString(init));
  }
};

URLSearchParamsState.prototype = {
  type: URL_SEARCH_PARAMS,
  bindURL: function (url) {
    this.url = url;
    this.update();
  },
  parseObject: function (object) {
    var entries = this.entries;
    var iteratorMethod = getIteratorMethod(object);
    var iterator, next, step, entryIterator, entryNext, first, second;

    if (iteratorMethod) {
      iterator = getIterator(object, iteratorMethod);
      next = iterator.next;
      while (!(step = call(next, iterator)).done) {
        entryIterator = getIterator(anObject(step.value));
        entryNext = entryIterator.next;
        if (
          (first = call(entryNext, entryIterator)).done ||
          (second = call(entryNext, entryIterator)).done ||
          !call(entryNext, entryIterator).done
        ) throw new TypeError$1('Expected sequence with length 2');
        push(entries, { key: $toString(first.value), value: $toString(second.value) });
      }
    } else for (var key in object) if (hasOwn(object, key)) {
      push(entries, { key: key, value: $toString(object[key]) });
    }
  },
  parseQuery: function (query) {
    if (query) {
      var entries = this.entries;
      var attributes = split(query, '&');
      var index = 0;
      var attribute, entry;
      while (index < attributes.length) {
        attribute = attributes[index++];
        if (attribute.length) {
          entry = split(attribute, '=');
          push(entries, {
            key: deserialize(shift(entry)),
            value: deserialize(join(entry, '='))
          });
        }
      }
    }
  },
  serialize: function () {
    var entries = this.entries;
    var result = [];
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      push(result, serialize(entry.key) + '=' + serialize(entry.value));
    } return join(result, '&');
  },
  update: function () {
    this.entries.length = 0;
    this.parseQuery(this.url.query);
  },
  updateURL: function () {
    if (this.url) this.url.update();
  }
};

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance(this, URLSearchParamsPrototype);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  var state = setInternalState(this, new URLSearchParamsState(init));
  if (!DESCRIPTORS) this.size = state.entries.length;
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

defineBuiltIns(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    var state = getInternalParamsState(this);
    validateArgumentsLength(arguments.length, 2);
    push(state.entries, { key: $toString(name), value: $toString(value) });
    if (!DESCRIPTORS) this.length++;
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name /* , value */) {
    var state = getInternalParamsState(this);
    var length = validateArgumentsLength(arguments.length, 1);
    var entries = state.entries;
    var key = $toString(name);
    var $value = length < 2 ? undefined : arguments[1];
    var value = $value === undefined ? $value : $toString($value);
    var index = 0;
    while (index < entries.length) {
      var entry = entries[index];
      if (entry.key === key && (value === undefined || entry.value === value)) {
        splice(entries, index, 1);
        if (value !== undefined) break;
      } else index++;
    }
    if (!DESCRIPTORS) this.size = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    var entries = getInternalParamsState(this).entries;
    validateArgumentsLength(arguments.length, 1);
    var key = $toString(name);
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    var entries = getInternalParamsState(this).entries;
    validateArgumentsLength(arguments.length, 1);
    var key = $toString(name);
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) push(result, entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name /* , value */) {
    var entries = getInternalParamsState(this).entries;
    var length = validateArgumentsLength(arguments.length, 1);
    var key = $toString(name);
    var $value = length < 2 ? undefined : arguments[1];
    var value = $value === undefined ? $value : $toString($value);
    var index = 0;
    while (index < entries.length) {
      var entry = entries[index++];
      if (entry.key === key && (value === undefined || entry.value === value)) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    var state = getInternalParamsState(this);
    validateArgumentsLength(arguments.length, 1);
    var entries = state.entries;
    var found = false;
    var key = $toString(name);
    var val = $toString(value);
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) splice(entries, index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) push(entries, { key: key, value: val });
    if (!DESCRIPTORS) this.size = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    arraySort(state.entries, function (a, b) {
      return a.key > b.key ? 1 : -1;
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
defineBuiltIn(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, { name: 'entries' });

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
defineBuiltIn(URLSearchParamsPrototype, 'toString', function toString() {
  return getInternalParamsState(this).serialize();
}, { enumerable: true });

// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (DESCRIPTORS) defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
  get: function size() {
    return getInternalParamsState(this).entries.length;
  },
  configurable: true,
  enumerable: true
});

setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$$2({ global: true, constructor: true, forced: !USE_NATIVE_URL }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!USE_NATIVE_URL && isCallable(Headers)) {
  var headersHas = uncurryThis$1(HeadersPrototype.has);
  var headersSet = uncurryThis$1(HeadersPrototype.set);

  var wrapRequestOptions = function (init) {
    if (isObject$1(init)) {
      var body = init.body;
      var headers;
      if (classof$1(body) === URL_SEARCH_PARAMS) {
        headers = init.headers ? new Headers(init.headers) : new Headers();
        if (!headersHas(headers, 'content-type')) {
          headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
        return create(init, {
          body: createPropertyDescriptor(0, $toString(body)),
          headers: createPropertyDescriptor(0, headers)
        });
      }
    } return init;
  };

  if (isCallable(nativeFetch)) {
    $$2({ global: true, enumerable: true, dontCallGetSet: true, forced: true }, {
      fetch: function fetch(input /* , init */) {
        return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      }
    });
  }

  if (isCallable(NativeRequest)) {
    var RequestConstructor = function Request(input /* , init */) {
      anInstance(this, RequestPrototype);
      return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
    };

    RequestPrototype.constructor = RequestConstructor;
    RequestConstructor.prototype = RequestPrototype;

    $$2({ global: true, constructor: true, dontCallGetSet: true, forced: true }, {
      Request: RequestConstructor
    });
  }
}

const generateCodeVerifier = () => {
  const allowedCharacters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
  const codeVerifierLength = 128;
  return genericUtils.generateRandomString(codeVerifierLength, allowedCharacters);
};
const generateCodeChallenge = base64Encode => codeVerifier => {
  const codeVerifierHash = cryptojs.SHA256(codeVerifier).toString();
  return encodeURIComponent(base64Encode(codeVerifierHash));
};
const generateAuthorizeUrl = authManagementBaseUrl => (codeChallenge, oAuthClientId, state, redirectUri) => {
  const searchParameters = new URLSearchParams();
  searchParameters.append('code_challenge_method', 'S256');
  searchParameters.append('code_challenge', codeChallenge);
  searchParameters.append('response_type', 'code');
  searchParameters.append('oauth_client_id', oAuthClientId);
  searchParameters.append('state', state);
  searchParameters.append('redirect_uri', redirectUri);
  return `${authManagementBaseUrl}/v1/authorize?${searchParameters.toString()}`;
};

const authorizationInfosFactory = (authManagementBaseUrl, base64Encode) => (oAuthClientId, redirectUri, askedUrl) => {
  const codeVerifier = generateCodeVerifier();
  const codeChallenge = generateCodeChallenge(base64Encode)(codeVerifier);
  const state = genericUtils.generateRandomString();
  const loginUrl = generateAuthorizeUrl(authManagementBaseUrl)(codeChallenge, oAuthClientId, state, redirectUri);
  return {
    askedUrl,
    codeVerifier,
    loginUrl,
    state
  };
};

var index$6 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    authorizationInfosFactory: authorizationInfosFactory
});

var index$5 = /*#__PURE__*/Object.freeze({
    __proto__: null
});

const applicationSessionFactory = () => (oautClientId, refreshToken) => {
  return {
    oAuthClientId: oautClientId,
    refreshToken
  };
};

var index$4 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    applicationSessionFactory: applicationSessionFactory
});

const refreshTokenUserResponseFactory = (encodeAccessTokenUser, encodeIdToken, encodeRefreshTokenUser) => (issuer, nonce, scopes, user, oAuthClientId, audienceUrl, secret) => {
  const scopesString = scopes.join(' ');
  const accessToken = encodeAccessTokenUser(issuer, user.id, audienceUrl, oAuthClientId, scopesString, nonce, secret);
  const idToken = encodeIdToken(issuer, user.id, audienceUrl, oAuthClientId, nonce, scopesString, user.firstName, user.lastName, user.email, secret, user.role);
  const refreshToken = encodeRefreshTokenUser(issuer, user.id, audienceUrl, oAuthClientId, nonce, scopesString, secret);
  return {
    accessToken,
    expiresIn: genericUtils.TIME.SECONDS_IN_AN_HOUR,
    idToken,
    refreshToken,
    scope: scopesString,
    tokenType: 'bearer'
  };
};
const refreshTokenApplicationResponseFactory = (encodeAccessTokenApplication, encodeRefreshTokenApplication) => (issuer, scopes, oAuthClientId, audienceUrl, secret) => {
  const scopesString = scopes.join(' ');
  const accessToken = encodeAccessTokenApplication(issuer, audienceUrl, oAuthClientId, scopesString, secret);
  const refreshToken = encodeRefreshTokenApplication(issuer, audienceUrl, oAuthClientId, scopesString, secret);
  return {
    accessToken,
    expiresIn: genericUtils.TIME.SECONDS_IN_AN_HOUR,
    refreshToken,
    scope: scopesString,
    tokenType: 'bearer'
  };
};

var index$3 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    refreshTokenApplicationResponseFactory: refreshTokenApplicationResponseFactory,
    refreshTokenUserResponseFactory: refreshTokenUserResponseFactory
});

const userSessionFactory = () => (oautClientId, userId, refreshToken) => {
  return {
    oAuthClientId: oautClientId,
    refreshToken,
    userId
  };
};

var index$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    userSessionFactory: userSessionFactory
});

var $$1 = _export;
var $includes = arrayIncludes.includes;
var fails = fails$j;
var addToUnscopables = addToUnscopables$2;

// FF99+ bug
var BROKEN_ON_SPARSE = fails(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$1({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

var ErrorValidationScope;
(function (ErrorValidationScope) {
  ErrorValidationScope[ErrorValidationScope["invalidScope"] = 0] = "invalidScope";
})(ErrorValidationScope || (ErrorValidationScope = {}));
const scopesRequired = ['openid', 'profile', 'email'];
const areRequiredScopesExisting = scopes => {
  const filterScopeRequired = scopes.filter(item => scopesRequired.includes(item));
  return filterScopeRequired.length === scopesRequired.length;
};

var ValidateScopesErrors;
(function (ValidateScopesErrors) {
  ValidateScopesErrors[ValidateScopesErrors["emptyScopes"] = 0] = "emptyScopes";
  ValidateScopesErrors[ValidateScopesErrors["missingRequiredScopes"] = 1] = "missingRequiredScopes";
})(ValidateScopesErrors || (ValidateScopesErrors = {}));
const validateScopes = scopes => {
  if (scopes.length === genericUtils.ARRAY.EMPTY_LENGTH) {
    return ValidateScopesErrors.emptyScopes;
  }
  if (areRequiredScopesExisting(scopes) === false) {
    return ValidateScopesErrors.missingRequiredScopes;
  }
};

var index$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    validateScopes: validateScopes,
    get ValidateScopesErrors () { return ValidateScopesErrors; }
});

var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    scopesValidation: index$1
});

var AuthorizeErrors;
(function (AuthorizeErrors) {
  AuthorizeErrors[AuthorizeErrors["inexistingOAuthClient"] = 0] = "inexistingOAuthClient";
  AuthorizeErrors[AuthorizeErrors["unregisteredRedirectUri"] = 1] = "unregisteredRedirectUri";
})(AuthorizeErrors || (AuthorizeErrors = {}));
var GetOneAccessTokenInfosErrors;
(function (GetOneAccessTokenInfosErrors) {
  GetOneAccessTokenInfosErrors[GetOneAccessTokenInfosErrors["invalidAccessToken"] = 0] = "invalidAccessToken";
  GetOneAccessTokenInfosErrors[GetOneAccessTokenInfosErrors["inexistingOAuthClient"] = 1] = "inexistingOAuthClient";
  GetOneAccessTokenInfosErrors[GetOneAccessTokenInfosErrors["inexistingOrganisation"] = 2] = "inexistingOrganisation";
  GetOneAccessTokenInfosErrors[GetOneAccessTokenInfosErrors["inexistingUser"] = 3] = "inexistingUser";
  GetOneAccessTokenInfosErrors[GetOneAccessTokenInfosErrors["inactiveUser"] = 4] = "inactiveUser";
})(GetOneAccessTokenInfosErrors || (GetOneAccessTokenInfosErrors = {}));
var AuthenticateErrors;
(function (AuthenticateErrors) {
  AuthenticateErrors[AuthenticateErrors["inexistingOAuthClient"] = 0] = "inexistingOAuthClient";
  AuthenticateErrors[AuthenticateErrors["unregisteredRedirectUri"] = 1] = "unregisteredRedirectUri";
  AuthenticateErrors[AuthenticateErrors["inexistingUser"] = 2] = "inexistingUser";
  AuthenticateErrors[AuthenticateErrors["invalidPassword"] = 3] = "invalidPassword";
  AuthenticateErrors[AuthenticateErrors["inactiveUser"] = 4] = "inactiveUser";
})(AuthenticateErrors || (AuthenticateErrors = {}));
var AuthorizationCodeExchangeErrors;
(function (AuthorizationCodeExchangeErrors) {
  AuthorizationCodeExchangeErrors[AuthorizationCodeExchangeErrors["inexistingOAuthClient"] = 0] = "inexistingOAuthClient";
  AuthorizationCodeExchangeErrors[AuthorizationCodeExchangeErrors["unregisteredRedirectUri"] = 1] = "unregisteredRedirectUri";
  AuthorizationCodeExchangeErrors[AuthorizationCodeExchangeErrors["invalidAuthorizationCode"] = 2] = "invalidAuthorizationCode";
  AuthorizationCodeExchangeErrors[AuthorizationCodeExchangeErrors["invalidCodeVerifier"] = 3] = "invalidCodeVerifier";
  AuthorizationCodeExchangeErrors[AuthorizationCodeExchangeErrors["inexistingUser"] = 4] = "inexistingUser";
  AuthorizationCodeExchangeErrors[AuthorizationCodeExchangeErrors["invalidScopes"] = 5] = "invalidScopes";
  AuthorizationCodeExchangeErrors[AuthorizationCodeExchangeErrors["inexistingOrganisation"] = 6] = "inexistingOrganisation";
  AuthorizationCodeExchangeErrors[AuthorizationCodeExchangeErrors["inactiveUser"] = 7] = "inactiveUser";
})(AuthorizationCodeExchangeErrors || (AuthorizationCodeExchangeErrors = {}));
var AuthorizationApplicationErrors;
(function (AuthorizationApplicationErrors) {
  AuthorizationApplicationErrors[AuthorizationApplicationErrors["inexistingOAuthClient"] = 0] = "inexistingOAuthClient";
  AuthorizationApplicationErrors[AuthorizationApplicationErrors["invalidOauthClient"] = 1] = "invalidOauthClient";
  AuthorizationApplicationErrors[AuthorizationApplicationErrors["invalidScopes"] = 2] = "invalidScopes";
  AuthorizationApplicationErrors[AuthorizationApplicationErrors["inexistingOrganisation"] = 3] = "inexistingOrganisation";
})(AuthorizationApplicationErrors || (AuthorizationApplicationErrors = {}));
var RefreshAccessTokenErrors;
(function (RefreshAccessTokenErrors) {
  RefreshAccessTokenErrors[RefreshAccessTokenErrors["inexistingSession"] = 0] = "inexistingSession";
  RefreshAccessTokenErrors[RefreshAccessTokenErrors["inexistingOAuthClient"] = 1] = "inexistingOAuthClient";
  RefreshAccessTokenErrors[RefreshAccessTokenErrors["invalidRefreshToken"] = 2] = "invalidRefreshToken";
  RefreshAccessTokenErrors[RefreshAccessTokenErrors["expiredRefreshToken"] = 3] = "expiredRefreshToken";
  RefreshAccessTokenErrors[RefreshAccessTokenErrors["inexistingUser"] = 4] = "inexistingUser";
  RefreshAccessTokenErrors[RefreshAccessTokenErrors["inexistingOrganisation"] = 5] = "inexistingOrganisation";
  RefreshAccessTokenErrors[RefreshAccessTokenErrors["inactiveUser"] = 6] = "inactiveUser";
})(RefreshAccessTokenErrors || (RefreshAccessTokenErrors = {}));
var CompleteAuthenticationProcessErrors;
(function (CompleteAuthenticationProcessErrors) {
  CompleteAuthenticationProcessErrors[CompleteAuthenticationProcessErrors["emptyState"] = 0] = "emptyState";
  CompleteAuthenticationProcessErrors[CompleteAuthenticationProcessErrors["inexistingAuthorizationInfos"] = 1] = "inexistingAuthorizationInfos";
  CompleteAuthenticationProcessErrors[CompleteAuthenticationProcessErrors["invalidState"] = 2] = "invalidState";
  CompleteAuthenticationProcessErrors[CompleteAuthenticationProcessErrors["inexistingAccessToken"] = 3] = "inexistingAccessToken";
})(CompleteAuthenticationProcessErrors || (CompleteAuthenticationProcessErrors = {}));

var applicationPorts = /*#__PURE__*/Object.freeze({
    __proto__: null,
    get AuthenticateErrors () { return AuthenticateErrors; },
    get AuthorizationApplicationErrors () { return AuthorizationApplicationErrors; },
    get AuthorizationCodeExchangeErrors () { return AuthorizationCodeExchangeErrors; },
    get AuthorizeErrors () { return AuthorizeErrors; },
    get CompleteAuthenticationProcessErrors () { return CompleteAuthenticationProcessErrors; },
    get GetOneAccessTokenInfosErrors () { return GetOneAccessTokenInfosErrors; },
    get RefreshAccessTokenErrors () { return RefreshAccessTokenErrors; }
});

var isObject = isObject$c;
var classof = classofRaw$2;
var wellKnownSymbol$1 = wellKnownSymbol$i;

var MATCH$1 = wellKnownSymbol$1('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classof(it) === 'RegExp');
};

var isRegExp = isRegexp;

var $TypeError = TypeError;

var notARegexp = function (it) {
  if (isRegExp(it)) {
    throw new $TypeError("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol = wellKnownSymbol$i;

var MATCH = wellKnownSymbol('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var $ = _export;
var uncurryThis = functionUncurryThis;
var notARegExp = notARegexp;
var requireObjectCoercible = requireObjectCoercible$5;
var toString = toString$3;
var correctIsRegExpLogic = correctIsRegexpLogic;

var stringIndexOf = uncurryThis(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(
      toString(requireObjectCoercible(this)),
      toString(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

const isRedirectUriValid = (registeredRedirectUris, redirectUri) => {
  return registeredRedirectUris.includes(redirectUri);
};

const authorize = getOneOauthClientById => (oauthClientId, redirectUri) => __awaiter(void 0, void 0, void 0, function* () {
  const oauthClient = yield getOneOauthClientById(oauthClientId);
  if (oauthClient === null) {
    return AuthorizeErrors.inexistingOAuthClient;
  }
  if (!isRedirectUriValid(oauthClient.redirectUris, redirectUri)) {
    return AuthorizeErrors.unregisteredRedirectUri;
  }
});
const authenticate = (getOneOauthClientById, getOneUserByEmail, comparePassword, encodeAuthorizationCode) => (oauthClientId, redirectUri, codeChallenge, state, email, password) => __awaiter(void 0, void 0, void 0, function* () {
  const oauthClient = yield getOneOauthClientById(oauthClientId);
  if (oauthClient === null) {
    return AuthenticateErrors.inexistingOAuthClient;
  }
  if (!isRedirectUriValid(oauthClient.redirectUris, redirectUri)) {
    return AuthenticateErrors.unregisteredRedirectUri;
  }
  const user = yield getOneUserByEmail(email.toLowerCase());
  if (user === null) {
    return AuthenticateErrors.inexistingUser;
  }
  if (user.active === false) {
    return AuthenticateErrors.inactiveUser;
  }
  const validPassword = yield comparePassword(password, user.passwordHash);
  if (!validPassword) {
    return AuthenticateErrors.invalidPassword;
  }
  const code = encodeAuthorizationCode(oauthClient.id, redirectUri, codeChallenge, user.id);
  return {
    code,
    state
  };
});
const authorizationCodeExchange = (getOneOauthClientById, decodeAuthorizationCode, validateCodeVerifier, getOneUserById, validateScopes, getOneOrganisationById, createOneAccessTokenUserResponse, saveOneUserSession, issuer) => (oAuthClientId, redirectUri, authorisationCode, codeVerifier, scopes, nonce) => __awaiter(void 0, void 0, void 0, function* () {
  const oAuthClient = yield getOneOauthClientById(oAuthClientId);
  if (oAuthClient === null) {
    return AuthorizationCodeExchangeErrors.inexistingOAuthClient;
  }
  if (!isRedirectUriValid(oAuthClient.redirectUris, redirectUri)) {
    return AuthorizationCodeExchangeErrors.unregisteredRedirectUri;
  }
  const authorizationCodeContent = decodeAuthorizationCode(authorisationCode);
  if (authorizationCodeContent === null) {
    return AuthorizationCodeExchangeErrors.invalidAuthorizationCode;
  }
  const isCodeVerifierValid = validateCodeVerifier(codeVerifier, authorizationCodeContent.codeChallenge);
  if (isCodeVerifierValid === false) {
    return AuthorizationCodeExchangeErrors.invalidCodeVerifier;
  }
  const user = yield getOneUserById(authorizationCodeContent.userId);
  if (user === null) {
    return AuthorizationCodeExchangeErrors.inexistingUser;
  }
  if (user.active === false) {
    return AuthorizationCodeExchangeErrors.inactiveUser;
  }
  const scopesValidationResult = validateScopes(scopes);
  if (genericUtils.isDomainError(scopesValidationResult, ValidateScopesErrors)) {
    return AuthorizationCodeExchangeErrors.invalidScopes;
  }
  const organisation = yield getOneOrganisationById(oAuthClient.organisationId);
  if (organisation === null) {
    return AuthorizationCodeExchangeErrors.inexistingOrganisation;
  }
  const accessTokenUserResponse = createOneAccessTokenUserResponse(issuer, nonce, scopes, user, oAuthClientId, organisation.url, oAuthClient.secret);
  const userSession = {
    oAuthClientId,
    refreshToken: accessTokenUserResponse.refreshToken,
    userId: user.id
  };
  yield saveOneUserSession(userSession);
  return accessTokenUserResponse;
});
const refreshAccessToken = (getOneSessionByRefreshToken, getOneOauthClientById, decodeRefreshToken, getOneUserById, getOneOrganisationById, createOneRefreshTokenUserResponse, createOneRefreshTokenApplicationResponse, deleteOneUserSessionByRefreshToken, saveOneUserSession, deleteOneApplicationSessionByRefreshToken, saveOneApplicationSession, issuer, applicationSessionFactory, userSessionFactory
// eslint-disable-next-line max-params
) =>
// eslint-disable-next-line max-statements
refreshToken => __awaiter(void 0, void 0, void 0, function* () {
  const oneSession = yield getOneSessionByRefreshToken(refreshToken);
  if (oneSession === null) {
    return RefreshAccessTokenErrors.inexistingSession;
  }
  const oAuthClient = yield getOneOauthClientById(oneSession.oAuthClientId);
  if (oAuthClient === null) {
    return RefreshAccessTokenErrors.inexistingOAuthClient;
  }
  const decodedRefreshToken = decodeRefreshToken(refreshToken, oAuthClient.secret);
  if (decodedRefreshToken === null) {
    return RefreshAccessTokenErrors.invalidRefreshToken;
  }
  const actualTime = Date.now() / genericUtils.TIME.MILLISECONDS_IN_A_SECOND;
  if (decodedRefreshToken.exp < actualTime) {
    return RefreshAccessTokenErrors.expiredRefreshToken;
  }
  const organisation = yield getOneOrganisationById(oAuthClient.organisationId);
  if (!organisation) {
    return RefreshAccessTokenErrors.inexistingOrganisation;
  }
  if (!('userId' in oneSession) && decodedRefreshToken.nonce === 'app') {
    const _refreshTokenResponse = createOneRefreshTokenApplicationResponse(issuer, decodedRefreshToken.scope.split(' '), oneSession.oAuthClientId, organisation.url, oAuthClient.secret);
    yield deleteOneApplicationSessionByRefreshToken(refreshToken);
    const applicationSession = applicationSessionFactory(oAuthClient.id, _refreshTokenResponse.refreshToken);
    yield saveOneApplicationSession(applicationSession);
    return _refreshTokenResponse;
  }
  const userSession = 'userId' in oneSession ? Object.assign({}, oneSession) : null;
  const user = userSession === null ? yield Promise.resolve(null) : yield getOneUserById(userSession.userId);
  if (user === null) {
    return RefreshAccessTokenErrors.inexistingUser;
  }
  if (user.active === false) {
    return RefreshAccessTokenErrors.inactiveUser;
  }
  const refreshTokenResponse = createOneRefreshTokenUserResponse(issuer, decodedRefreshToken.nonce, decodedRefreshToken.scope.split(' '), user, oneSession.oAuthClientId, organisation.url, oAuthClient.secret);
  yield deleteOneUserSessionByRefreshToken(refreshToken);
  const newUserSession = userSessionFactory(oAuthClient.id, user.id, refreshTokenResponse.refreshToken);
  yield saveOneUserSession(newUserSession);
  return refreshTokenResponse;
});
const revokeUserSession = (deleteOneUserSessionByRefreshToken, deleteOneApplicationSessionByRefreshToken) => refreshToken => __awaiter(void 0, void 0, void 0, function* () {
  yield Promise.all([deleteOneUserSessionByRefreshToken(refreshToken), deleteOneApplicationSessionByRefreshToken(refreshToken)]);
});
const getOneAccessTokenInfos = (decodeAccessToken, getOneOauthClientById, getOneOrganisationById, verifyAccessToken, getOneUserById) => accessToken => __awaiter(void 0, void 0, void 0, function* () {
  const accessTokenInfos = decodeAccessToken(accessToken);
  if (accessTokenInfos === null) {
    return GetOneAccessTokenInfosErrors.invalidAccessToken;
  }
  const oAuthClient = yield getOneOauthClientById(accessTokenInfos.oAuthClientId);
  if (oAuthClient === null) {
    return GetOneAccessTokenInfosErrors.inexistingOAuthClient;
  }
  const organisation = yield getOneOrganisationById(oAuthClient.organisationId);
  if (organisation === null) {
    return GetOneAccessTokenInfosErrors.inexistingOrganisation;
  }
  const isAccessTokenValid = verifyAccessToken(accessToken, oAuthClient.secret, organisation.url);
  if (isAccessTokenValid === false) {
    return GetOneAccessTokenInfosErrors.invalidAccessToken;
  }
  if (accessTokenInfos.type === 'user') {
    const user = yield getOneUserById(accessTokenInfos.identifiant);
    if (user === null) {
      return GetOneAccessTokenInfosErrors.inexistingUser;
    }
    if (user.active === false) {
      return GetOneAccessTokenInfosErrors.inactiveUser;
    }
  }
  return accessTokenInfos;
});
const createAuthorizationInfos = (authorizationInfosFactory, saveOneAuthorizationInfos) => (oAuthClientId, redirectUri, askedUrl) => __awaiter(void 0, void 0, void 0, function* () {
  const authorizationInfos = authorizationInfosFactory(oAuthClientId, redirectUri, askedUrl);
  yield saveOneAuthorizationInfos(authorizationInfos);
  return authorizationInfos;
});
const completeAuthenticationProcess = (getOneAuthorizationInfos, deleteOneAuthorizationInfos, exchangeAuthorizationCodeWithAccessToken, saveOneAccessTokenResponse, oauthClientId, oauthRedirectUri, scopes) => (authorizationCode, state) => __awaiter(void 0, void 0, void 0, function* () {
  if (genericUtils.isString(state) === false) {
    return CompleteAuthenticationProcessErrors.emptyState;
  }
  const authorizationsInfos = yield getOneAuthorizationInfos();
  if (authorizationsInfos === null) {
    return CompleteAuthenticationProcessErrors.inexistingAuthorizationInfos;
  }
  if (authorizationsInfos.state !== state) {
    return CompleteAuthenticationProcessErrors.invalidState;
  }
  yield deleteOneAuthorizationInfos();
  const accessTokenResponse = yield exchangeAuthorizationCodeWithAccessToken(oauthClientId, oauthRedirectUri, authorizationCode, authorizationsInfos.codeVerifier, scopes.split(' '), genericUtils.generateRandomString());
  if (accessTokenResponse === null) {
    return CompleteAuthenticationProcessErrors.inexistingAccessToken;
  }
  yield saveOneAccessTokenResponse(accessTokenResponse);
  return authorizationsInfos;
});
const authorizationApplication = (getOneOauthClientById, validateScopes, getOneOrganisationById, createOneAccessTokenApplicationResponse, saveOneApplicationSession, issuer) => (oAuthClientId, oauthClientSecret, scopes) => __awaiter(void 0, void 0, void 0, function* () {
  const oAuthClient = yield getOneOauthClientById(oAuthClientId);
  if (oAuthClient === null) {
    return AuthorizationApplicationErrors.inexistingOAuthClient;
  }
  if (oauthClientSecret !== oAuthClient.secret) {
    return AuthorizationApplicationErrors.invalidOauthClient;
  }
  const scopesValidationResult = validateScopes(scopes);
  if (genericUtils.isDomainError(scopesValidationResult, ValidateScopesErrors)) {
    return AuthorizationApplicationErrors.invalidScopes;
  }
  const organisation = yield getOneOrganisationById(oAuthClient.organisationId);
  if (organisation === null) {
    return AuthorizationApplicationErrors.inexistingOrganisation;
  }
  const accessTokenResponse = createOneAccessTokenApplicationResponse(issuer, scopes, oAuthClientId, organisation.url, oAuthClient.secret);
  const applicationSession = {
    oAuthClientId,
    refreshToken: accessTokenResponse.refreshToken
  };
  yield saveOneApplicationSession(applicationSession);
  return accessTokenResponse;
});

export { index$7 as accessTokenResponseModel, applicationPorts as appPorts, authenticate, authorizationApplication, authorizationCodeExchange, index$6 as authorizationInfosModel, index$5 as authorizationResponseModel, authorize, index$f as axiosAuthenticationService, index$b as bcryptPasswordService, completeAuthenticationProcess, index$h as cookiesAccessTokenResponseRepository, createAuthorizationInfos, entitiesSchemas$1 as entitiesSchemas, getOneAccessTokenInfos, index$a as jwtTokenService, index$e as localstorageAuthorizationInfosRepository, index$4 as oauthModel, index$g as postgresqlApplicationSessionsRepository, index$8 as postgresqlAxiosUsersRepository, index$d as postgresqlOauthClientsRepository, index$c as postgresqlOrganisationsRepository, index$9 as postgresqlUserSessionsRepository, refreshAccessToken, index$3 as refreshTokenResponseModel, revokeUserSession, index$1 as scopesValidationService, index as services, index$2 as userModel };
